import React, { useEffect, useState } from 'react'
import { IoMdArrowBack, IoMdClose } from 'react-icons/io'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { FaCircleChevronRight, FaRegCircleCheck, FaRightLong } from "react-icons/fa6";
import { FaRegCircleXmark } from "react-icons/fa6";
import Button from 'react-bootstrap/Button';
import tickIcon from "../../assets/svg/Tick Square.svg"
import closeIcon from "../../assets/svg/Close Square.svg"
import { approveOrder, deleteOrderProduct, downloadCustomerOrderInvoice, downloadVendorOrderInvoice, exchangeorRejectOrder, getOrderDetails, rejectOrder, shipOrder } from '../../api/context/orders';
import moment from 'moment';
import { Col, Modal, Row, Spinner, Table, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { FaDownload } from "react-icons/fa6";
import Loader from '../../components/loader/loader';
import { AiOutlineDeliveredProcedure } from "react-icons/ai";
import { FaRegCopy } from "react-icons/fa6";
import { getBaseUrl } from '../../helpers/helper';
import { checkUserPermissions } from "../../helpers/permission";


import {
    FaRegCalendarAlt,
    FaMoneyBillWave,
    FaCreditCard,
    FaCheckCircle,
    FaTimesCircle,
    FaTruck,
    FaBoxOpen,
    FaShippingFast,
    FaExchangeAlt,
    FaMapMarkerAlt
} from 'react-icons/fa';
import { FiImage, FiRefreshCw, FiCalendar, FiCreditCard, FiDollarSign, FiCheckCircle, FiXCircle, FiTruck, FiPackage, FiMapPin, FiSend, FiPlayCircle, FiX } from 'react-icons/fi';
import { BsImageAlt } from 'react-icons/bs';
import ErrorState from '../../components/Error/errorState';

const customStyles = `
  .custom-rounded {
    border-radius: 8px 8px 8px 8px !important;
  }
  .custom-rounded-card {
    border-radius: 12px 12px 12px 12px !important;
    border: none !important;
  }
  .custom-rounded-img {
    border-radius: 4px 4px 4px 4px !important;
  }
  .custom-rounded-btn {
    border-radius: 4px 4px 4px 4px !important;
  }
  .custom-rounded-modal .modal-content {
    border-radius:  12px 12px 12px 12px !important;
    border: none !important;
  }
  .custom-rounded-table {
    border-radius: 8px 8px 8px 8px !important;
    overflow: hidden;
  }
  .custom-rounded-table th:first-child,
  .custom-rounded-table td:first-child {
    border-left: none;
  }
  .custom-rounded-table th:last-child,
  .custom-rounded-table td:last-child {
    border-right: none;
  }
  .otp-container .order-otp {
    border-radius: 4px 4px 4px 4px !important;
  }
  .color-code {
    border-radius: 50% 50% 50% 50% !important;
  }
  .vertical-divider {
    border-left: 1px solid #dee2e6;
    height: 100%;
  }
`;

const OrderDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state;
    const { id } = useParams();

    const [orderId, setOrderID] = useState([id]);
    const [orderIdSingle, setOrderIDSingle] = useState(id);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [update, setUpdate] = useState(false)
    const [orderData, setOrderData] = useState([]);
    const [downloadVendorInvoice, setDownloadVendorInvoice] = useState(false)
    const [downloadCustomerInvoice, setDownloadCustomerInvoice] = useState(false)
    const [showOrder, setShowOrder] = useState(false);
    const [orderItem, setOrderItem] = useState({
        id: "",
        type: "",
        status: "",
        orderItemProducts: ""
    });

    const [stickyVideo, setStickyVideo] = useState(null);
    const [showEvidenceModal, setShowEvidenceModal] = useState(false);
    const [evidenceAction, setEvidenceAction] = useState(null); // 'REJECT' | 'APPROVE'
    const [showRejectConfirm, setShowRejectConfirm] = useState(false);
    const [rejectionReason, setRejectionReason] = useState('');
    const [customReason, setCustomReason] = useState('');
    const [showVideoPreview, setShowVideoPreview] = useState(false);
    const [videoPreviewData, setVideoPreviewData] = useState({ videoUrl: null, reason: '', comments: '', orderId: '', orderType: null });
    const [showApproveConfirm, setShowApproveConfirm] = useState(false);


    const handleRefresh = () => {
        setError(false);
        setRefreshing(true);
        setLoading(true);

        // Refresh all order-related data
        getOrderDetails(id)((response) => {
            if (response?.data?.statusCode == 200) {
                setOrderData(response?.data?.data?.[0]);

                // If it's a return/exchange order, refresh evidence video
                if (response?.data?.data?.[0]?.orderType === 1 || response?.data?.data?.[0]?.orderType === 2) {
                    const videoUrl = getEvidenceVideoUrl();
                    if (videoUrl && !stickyVideo) {
                        const orderType = response?.data?.data?.[0]?.orderType === 1 ? 'Return' :
                            response?.data?.data?.[0]?.orderType === 2 ? 'Exchange' : 'Evidence';
                        setStickyVideo({
                            url: videoUrl,
                            type: orderType,
                            returnId: response?.data?.data?.[0]?.id
                        });
                    }
                }

                toast.success('Order details refreshed successfully!');
            } else {
                toast.error('Failed to refresh order details');
                setOrderData([]);
                setError(true);
            }
            setRefreshing(false);
            setLoading(false);
        });
    };

    // Rejection reasons
    const rejectionReasons = [
        "Product damaged by customer",
        "Wrong product returned",
        "Return period expired",
        "Missing original packaging",
        "Product used/worn",
    ];


    const handleEvidenceModalShow = () => {
        setShowEvidenceModal(true);
        setRejectionReason('');
        setCustomReason('');
    }

    const handleEvidenceModalClose = () => {
        setShowEvidenceModal(false);
        setRejectionReason('');
        setCustomReason('');
    }

    const handleRejectOrder = () => {
        // If no dropdown reason selected but custom reason has sufficient text
        if (!rejectionReason && customReason && customReason.trim().length >= 10) {
            // Use the custom reason directly
            const finalReason = customReason;

            setEvidenceAction('REJECT');
            setLoading(true);
            rejectOrder({
                orderIds: [id],
                reason: finalReason
            })((response) => {
                if (response?.data?.statusCode == 200) {
                    toast.success(response?.data?.message ? response?.data?.message : "Order rejected successfully", 'success');
                    navigate('/orders');
                } else {
                    toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error');
                    setLoading(false);
                    setEvidenceAction(null);
                }
            });
            return;
        }

        // Original logic for dropdown selection
        if (!rejectionReason) {
            toast.error("Please select a reason for rejection or provide a custom reason");
            return;
        }

        if (rejectionReason === "Other (specify below)" && !customReason.trim()) {
            toast.error("Please specify the reason for rejection");
            return;
        }

        const finalReason = rejectionReason === "Other (specify below)" ? customReason : rejectionReason;

        setEvidenceAction('REJECT');
        setLoading(true);
        rejectOrder({
            orderIds: [id],
            reason: finalReason
        })((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Order rejected successfully", 'success');
                navigate('/orders');
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error');
                setLoading(false);
                setEvidenceAction(null);
            }
        });
    };

    // Get evidence video URL
    // Get evidence video URL - Updated version
    const getEvidenceVideoUrl = () => {
        // Check current order's orderProducts first
        if (orderData && orderData.orderProducts) {
            const allReturns = orderData.orderProducts.flatMap(product =>
                product.returns || []
            );

            const returnsWithVideos = allReturns.filter(returnItem =>
                returnItem.returnImages && returnItem.returnImages.length > 0
            );

            if (returnsWithVideos.length > 0) {
                const firstReturnWithVideo = returnsWithVideos[0];
                const videoImage = firstReturnWithVideo.returnImages.find(img =>
                    img.mediaType === 'video'
                );
                return videoImage?.mediaUrl;
            }
        }

        // If not found in current order, check baseOrder
        if (orderData && orderData.baseOrder && orderData.baseOrder.orderProducts) {
            const baseOrderReturns = orderData.baseOrder.orderProducts.flatMap(product =>
                product.returns || []
            );

            const baseReturnsWithVideos = baseOrderReturns.filter(returnItem =>
                returnItem.returnImages && returnItem.returnImages.length > 0
            );

            if (baseReturnsWithVideos.length > 0) {
                const firstReturnWithVideo = baseReturnsWithVideos[0];
                const videoImage = firstReturnWithVideo.returnImages.find(img =>
                    img.mediaType === 'video'
                );
                return videoImage?.mediaUrl;
            }
        }

        return null;
    };

    const evidenceVideoUrl = getEvidenceVideoUrl();


    const otp = state?.otp || [1, 2, 3, 4];

    const handleOrderShow = (orderitem) => {
        setShowOrder(true);
        setOrderItem({ id: orderitem?.returns?.[0]?.id, type: orderitem?.returns?.[0]?.type, status: orderitem?.returns?.[0]?.status, orderItemProducts: orderitem })
    }

    const renderOtpDigits = (otp) => {
        if (!otp) return null;
        const digits = otp.toString().split('');
        return digits.map((digit, index) => (
            <div key={index} className='order-otp bg-light border p-2 mx-1'>{digit}</div>
        ));
    };

    const handleCloseOrder = () => {
        setShowOrder(false);
    };

    const copyToClipBoard = () => {
        const table = document.querySelector('.delivery-details-table');
        if (!table) return;
        const rows = table.querySelectorAll('tr');
        let formattedText = "";
        rows.forEach(row => {
            const cells = row.querySelectorAll('td');
            let rowText = [];
            cells.forEach(cell => {
                rowText.push(cell.textContent.trim());
            });
            formattedText += rowText.join(': ') + "\n";
        });

        navigator.clipboard.writeText(formattedText).then(() => {
            toast.success("Order details copied");
        }).catch(err => console.error('Failed to copy: ', err));
    };

    const handleOrderStatusChange = (status, successMessage) => {
        if (showEvidenceModal) setEvidenceAction('APPROVE');
        setLoading(true);
        approveOrder({ orderIds: [id], status })((response) => {
            if (response?.data?.statusCode === 200) {
                toast.success(response?.data?.message || successMessage, 'success');
                navigate('/orders')
            } else {
                toast.error(response?.data?.message || "Something went wrong", 'error');
            }
            setLoading(false);
            setEvidenceAction(null);
        });
    };

    const handleApproveOrder = () => {
        handleOrderStatusChange("CONFIRMED", "Order accepted successfully");
    };

    // Opens the "product review" approval confirmation modal used by all order types.
    // Actual API call fires from confirmApproveOrder() when the vendor confirms in that modal.
    const openApproveConfirm = () => {
        if (!id || loading) return;
        setShowApproveConfirm(true);
    };
    const confirmApproveOrder = () => {
        if (!id || loading) return;
        setShowApproveConfirm(false);
        handleOrderStatusChange("CONFIRMED", "Order accepted successfully");
    };

    const handleMarkAsDelivered = () => {
        handleOrderStatusChange("DELIVERED", "Order marked as delivered successfully");
    };

    const handleCancelOrder = () => {
        const needsReason = orderData?.orderType === 1 || orderData?.orderType === 2;
        let finalReason = null;
        if (needsReason) {
            if (rejectionReason) finalReason = rejectionReason;
            else if (customReason && customReason.trim().length >= 10) finalReason = customReason.trim();
            else {
                toast.error('Please select a reason or provide a custom reason (min. 10 characters)');
                return;
            }
        }
        setLoading(true);
        const payload = { orderIds: [id] };
        if (finalReason) payload.reason = finalReason;
        rejectOrder(payload)((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Order cancelled successfully", 'success')
                setShowRejectConfirm(false)
                setRejectionReason('');
                setCustomReason('');
                navigate('/orders')
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
                setLoading(false)
            }
        })
    }

    // Extract video URL + customer's reason/comment from the loaded orderData (for exchange/return).
    const getEvidenceInfoFromOrder = () => {
        const pickFromProducts = (products) => {
            if (!Array.isArray(products)) return null;
            for (const p of products) {
                const returns = p?.returns || [];
                for (const r of returns) {
                    const video = (r?.returnImages || []).find(img => img?.mediaType === 'video');
                    if (video?.mediaUrl || r?.reason || r?.comments) {
                        return { videoUrl: video?.mediaUrl || null, reason: r?.reason || '', comments: r?.comments || '' };
                    }
                }
            }
            return null;
        };
        return pickFromProducts(orderData?.orderProducts) || pickFromProducts(orderData?.baseOrder?.orderProducts) || { videoUrl: null, reason: '', comments: '' };
    };

    // Opens the compact video-preview modal (video + reason + comment + Reject/Accept in footer).
    const openVideoPreview = () => {
        const info = getEvidenceInfoFromOrder();
        setVideoPreviewData({
            videoUrl: info?.videoUrl || null,
            reason: info?.reason || '',
            comments: info?.comments || '',
            orderId: orderData?.orderId || '',
            orderType: orderData?.orderType || null,
        });
        setShowVideoPreview(true);
    };
    const closeVideoPreview = () => {
        setShowVideoPreview(false);
        setVideoPreviewData({ videoUrl: null, reason: '', comments: '', orderId: '', orderType: null });
    };
    const handleVideoPreviewAccept = () => {
        setShowVideoPreview(false);
        setShowApproveConfirm(true);
    };
    const handleVideoPreviewReject = () => {
        setShowVideoPreview(false);
        setRejectionReason('');
        setCustomReason('');
        setShowRejectConfirm(true);
    };

    const cancelProductOrder = (id) => {
        deleteOrderProduct(id)((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Product deleted successfully", 'success')
                setUpdate(!update)
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
                setUpdate(!update)
            }
        })
    }

    const handleShipOrder = () => {
        setLoading(true)
        shipOrder({ orderId: [id] })((response) => {
            if (response?.data?.statusCode == 200) {
                toast.success(response?.data?.message ? response?.data?.message : "Order added successfully", 'success')
                setUpdate(!update)
            } else {
                toast.error(response?.data?.message ? response?.data?.message : "Something went wrong", 'error')
                setLoading(false)
            }
        })
    }

    const handleDownloadVendorInvoice = () => {
        setDownloadVendorInvoice(true);

        downloadVendorOrderInvoice({
            responseType: 'blob',
            params: { orderId: orderIdSingle }
        })((response) => {
            try {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `invoice-ord${orderIdSingle}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                toast.error("Failed to download invoice");
            } finally {
                setDownloadVendorInvoice(false);
            }
        });
    };

    const handleDownloadCustomerInvoice = () => {
        setDownloadCustomerInvoice(true);

        downloadCustomerOrderInvoice({
            responseType: 'blob',
            params: { orderId: orderIdSingle }
        })((response) => {
            try {
                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `invoice-ord${orderIdSingle}.pdf`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
            } catch (err) {
                toast.error("Failed to download invoice");
            } finally {
                setDownloadCustomerInvoice(false);
            }
        });
    };

    const handleOrderReturnExchange = (id, status) => {
        setLoading(true);
        exchangeorRejectOrder({ id, status })((response) => {
            if (response?.data?.status) {
                toast.success(response?.data?.message);
                setUpdate(prevUpdate => !prevUpdate);
                setShowOrder(false)
            } else {
                toast.error(response?.data?.message || "Something went wrong", 'error');
            }
            setLoading(false);
        });
    };

    useEffect(() => {
        if (id) {
            setLoading(true)
            getOrderDetails(id)((response) => {
                if (response?.data?.statusCode == 200) {
                    setOrderData(response?.data?.data?.[0]);
                    setLoading(false)
                } else {
                    setOrderData([])
                    setError(true);
                    setLoading(false)
                }
            })
        }
    }, [id]);

    // Auto-detect and show video when order data loads with returns/exchanges
    useEffect(() => {
        if (orderData) {
            const videoUrl = getEvidenceVideoUrl();

            if (videoUrl && !stickyVideo) {
                // Determine the type from orderData
                const orderType = orderData.orderType === 1 ? 'Return' :
                    orderData.orderType === 2 ? 'Exchange' : 'Evidence';

                setStickyVideo({
                    url: videoUrl,
                    type: orderType,
                    // You might need to adjust how you get the returnId
                    returnId: orderData.id // or appropriate ID
                });
            }
        }
    }, [orderData, stickyVideo]);

    const NotMaskedUserData = () => (
        <Table className="custom-rounded-table">
            <tbody>
                <tr>
                    <td className='user-details-subheading'>User Name:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerName ? orderData.Address.customerName : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Mobile Number:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile}` : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Email Address:</td>
                    <td className='user-details-data'>{orderData?.Address?.customerEmail ? `${orderData?.Address?.customerEmail}` : 'N/A'}</td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Address: </td>
                    <td className='user-details-data'>
                        <div className='user-details-address'>{orderData?.Address?.line1 + ',' + orderData?.Address?.line2 + "," + orderData?.Address?.locality}</div>
                        <div className='user-details-address'>{orderData?.Address?.city + ',' + orderData?.Address?.state + ',' + 'Pincode:' + orderData?.Address?.postalCode}</div></td>
                </tr>
            </tbody>
        </Table>);

    const MaskedUserData = () => (
        <Table className="custom-rounded-table">
            <tbody>
                <tr>
                    <td className='user-details-subheading'>User Name:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerName ? `${orderData.Address.customerName.charAt(0) + "****"}` : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Mobile Number:</td>
                    <td className='user-details-data'>
                        {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile.slice(0, 3) + `*******`}` : "N/A"}
                    </td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Email Address:</td>
                    <td className='user-details-data'>{orderData?.Address?.customerEmail ? `${orderData?.Address?.customerEmail.slice(0, 3) + `****@gmail.com`}` : '*****@gmail.com'}</td>
                </tr>
                <tr>
                    <td className='user-details-subheading'>Address: </td>
                    <td className='user-details-data'>
                        <div>{orderData?.Address?.line1 + ',' + orderData?.Address?.line2 + "," + orderData?.Address?.locality}</div>
                        <div>{orderData?.Address?.city + ',' + orderData?.Address?.state + ',' + 'Pincode:' + orderData?.Address?.postalCode}</div>
                    </td>
                </tr>
            </tbody>
        </Table>);

    const userType = JSON.parse(localStorage.getItem('user'))?.userType;


    const OrderStatusTracker = ({ status, type, paymentMode, paymentStatus, pidgeOrder }) => {
        // Updated color palette with more professional colors
        const statusColors = {
            INITIATED: '#6B7280',  // Gray
            ONLINE: '#10B981',     // Emerald
            CONFIRMED: '#3B82F6',   // Blue
            DELIVERED: '#10B981',   // Emerald
            REJECTED: '#EF4444',    // Red
            CANCELLED: '#EF4444',   // Red
            COD: '#06B6D4',         // Cyan
            PENDING: '#F59E0B',     // Amber
            OUT_FOR_PICKUP: '#F97316', // Orange
            REACHED_PICKUP: '#F59E0B', // Amber (similar to PENDING)
            PICKED_UP: '#14B8A6',   // Teal
            OUT_FOR_DELIVERY: '#8B5CF6', // Violet
            REACHED_DELIVERY: '#8B5CF6', // Violet (similar to OUT_FOR_DELIVERY)
        };

        const isReturnOrder = type === 1;

        const getSteps = () => {
            // Base steps for all order types
            let steps = [
                {
                    id: 1,
                    name: isReturnOrder ? 'Return Placed' : 'Order Placed',
                    statuses: ['INITIATED'],
                    color: statusColors.INITIATED,
                    icon: <FiCalendar size={11} strokeWidth={2.2} />,
                    completedIcon: <FiCalendar size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: <FiCalendar size={11} strokeWidth={2.2} className="text-white" />
                },
                // Skip payment step for return orders
                ...(isReturnOrder ? [] : [{
                    id: 2,
                    name: paymentMode === 'COD'
                        ? paymentStatus === 'PENDING'
                            ? 'Pending Payment'
                            : 'Cash on Delivery'
                        : paymentStatus === 'DONE'
                            ? 'Online Paid'
                            : 'Payment Pending',
                    statuses: ['CONFIRMED', 'REJECTED', 'CANCELLED', 'DELIVERED'],
                    color: paymentMode === 'COD'
                        ? paymentStatus === 'PENDING'
                            ? statusColors.PENDING
                            : statusColors.COD
                        : paymentStatus === 'DONE'
                            ? statusColors.ONLINE
                            : statusColors.PENDING,
                    icon: paymentMode === 'COD'
                        ? <FiDollarSign size={11} strokeWidth={2.2} />
                        : <FiCreditCard size={11} strokeWidth={2.2} />,
                    completedIcon: paymentMode === 'COD'
                        ? <FiDollarSign size={11} strokeWidth={2.2} className="text-white" />
                        : <FiCreditCard size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: paymentMode === 'COD'
                        ? <FiDollarSign size={11} strokeWidth={2.2} className="text-white" />
                        : <FiCreditCard size={11} strokeWidth={2.2} className="text-white" />
                }]),
                {
                    id: isReturnOrder ? 2 : 3,
                    name: isReturnOrder
                        ? status === 'REJECTED' ? 'Return Rejected'
                            : status === 'CANCELLED' ? 'Return Cancelled'
                                : 'Return Confirmed'
                        : status === 'REJECTED' ? 'Order Rejected'
                            : status === 'CANCELLED' ? 'Order Cancelled'
                                : 'Order Confirmed',
                    statuses: ['CONFIRMED', 'REJECTED', 'CANCELLED'],
                    color: status === 'REJECTED' || status === 'CANCELLED' ?
                        statusColors.REJECTED : statusColors.CONFIRMED,
                    icon: status === 'REJECTED' || status === 'CANCELLED'
                        ? <FiXCircle size={11} strokeWidth={2.2} />
                        : <FiCheckCircle size={11} strokeWidth={2.2} />,
                    completedIcon: status === 'REJECTED' || status === 'CANCELLED' ?
                        <FiXCircle size={11} strokeWidth={2.2} className="text-white" /> :
                        <FiCheckCircle size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: status === 'REJECTED' || status === 'CANCELLED' ?
                        <FiXCircle size={11} strokeWidth={2.2} className="text-white" /> :
                        <FiCheckCircle size={11} strokeWidth={2.2} className="text-white" />
                },
                {
                    id: isReturnOrder ? 3 : 4,
                    name: isReturnOrder ? 'Return Picked Up' : 'Out for Pickup',
                    statuses: ['OUT_FOR_PICKUP'],
                    color: statusColors.OUT_FOR_PICKUP,
                    icon: <FiTruck size={11} strokeWidth={2.2} />,
                    completedIcon: <FiTruck size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: <FiTruck size={11} strokeWidth={2.2} className="text-white" />
                },
                {
                    id: isReturnOrder ? 4 : 5,
                    name: isReturnOrder ? 'Reached Pickup' : 'Reached Pickup',
                    statuses: ['REACHED_PICKUP'],
                    color: statusColors.REACHED_PICKUP,
                    icon: <FiMapPin size={11} strokeWidth={2.2} />,
                    completedIcon: <FiMapPin size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: <FiMapPin size={11} strokeWidth={2.2} className="text-white" />
                },
                {
                    id: isReturnOrder ? 5 : 6,
                    name: isReturnOrder ? 'Return Processed' : 'Order Picked',
                    statuses: ['PICKED_UP'],
                    color: statusColors.PICKED_UP,
                    icon: <FiPackage size={11} strokeWidth={2.2} />,
                    completedIcon: <FiPackage size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: <FiPackage size={11} strokeWidth={2.2} className="text-white" />
                },
                {
                    id: isReturnOrder ? 6 : 7,
                    name: isReturnOrder ? 'Return Shipped' : 'Out for Delivery',
                    statuses: ['OUT_FOR_DELIVERY'],
                    color: statusColors.OUT_FOR_DELIVERY,
                    icon: <FiSend size={11} strokeWidth={2.2} />,
                    completedIcon: <FiSend size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: <FiSend size={11} strokeWidth={2.2} className="text-white" />
                },
                {
                    id: isReturnOrder ? 7 : 8,
                    name: isReturnOrder ? 'Reached Delivery' : 'Reached Delivery',
                    statuses: ['REACHED_DELIVERY'],
                    color: statusColors.REACHED_DELIVERY,
                    icon: <FiMapPin size={11} strokeWidth={2.2} />,
                    completedIcon: <FiMapPin size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: <FiMapPin size={11} strokeWidth={2.2} className="text-white" />
                },
                {
                    id: isReturnOrder ? 8 : 9,
                    name: isReturnOrder ? 'Return Completed' : 'Order Delivered',
                    statuses: ['DELIVERED'],
                    color: statusColors.DELIVERED,
                    icon: <FiCheckCircle size={11} strokeWidth={2.2} />,
                    completedIcon: <FiCheckCircle size={11} strokeWidth={2.2} className="text-white" />,
                    activeIcon: <FiCheckCircle size={11} strokeWidth={2.2} className="text-white" />
                }
            ];

            return steps;
        };

        const getCurrentStep = () => {
            const steps = getSteps();
            const stepIds = steps.map(step => step.id);

            // Both regular and return orders follow the same status flow
            switch (status) {
                case 'INITIATED':
                    if (isReturnOrder) return 1;
                    return paymentStatus === 'DONE' || paymentMode === 'COD' ?
                        stepIds.indexOf(2) + 1 : // Payment step
                        stepIds.indexOf(1) + 1;  // Order placed step
                case 'CONFIRMED':
                    if (!pidgeOrder) return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                    switch (pidgeOrder.fulfillmentStatus) {
                        case 'CREATED': return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                        case 'OUT_FOR_PICKUP': return stepIds.indexOf(isReturnOrder ? 3 : 4) + 1;
                        case 'REACHED_PICKUP': return stepIds.indexOf(isReturnOrder ? 4 : 5) + 1;
                        case 'PICKED_UP': return stepIds.indexOf(isReturnOrder ? 5 : 6) + 1;
                        case 'OUT_FOR_DELIVERY': return stepIds.indexOf(isReturnOrder ? 6 : 7) + 1;
                        case 'REACHED_DELIVERY': return stepIds.indexOf(isReturnOrder ? 7 : 8) + 1;
                        default: return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                    }
                case 'DELIVERED': return stepIds.indexOf(isReturnOrder ? 8 : 9) + 1;
                case 'REJECTED':
                case 'CANCELLED':
                    return stepIds.indexOf(isReturnOrder ? 2 : 3) + 1;
                default: return 0;
            }
        };

        const steps = getSteps();
        const currentStepIndex = getCurrentStep();
        const currentStepId = steps[currentStepIndex - 1]?.id;

        return (
            <div className="order-tracker-container mb-4 p-3 rounded-lg">
                <div className="d-flex justify-content-between position-relative">
                    {/* Progress line */}
                    <div className="progress-line position-absolute"
                        style={{
                            height: '2px',
                            top: '12px',
                            left: '40px',
                            right: '40px',
                            backgroundColor: '#F3F4F6',
                            zIndex: 1,
                            borderRadius: '2px',
                            overflow: 'hidden'
                        }}>
                        <div className="progress-active"
                            style={{
                                height: '100%',
                                width: `${((currentStepIndex - 1) / (steps.length - 1)) * 100}%`,
                                backgroundColor: '#D1D5DB',
                                transition: 'width 0.6s ease',
                                zIndex: 2,
                                borderRadius: '2px'
                            }}>
                        </div>
                    </div>

                    {steps.map((step, index) => {
                        const isCompleted = index < currentStepIndex;
                        const isCurrent = index === currentStepIndex - 1;
                        const isActive = isCompleted || isCurrent;

                        const stepColor = isActive ? step.color : '#E5E7EB';
                        const textColor = isActive ? step.color : '#9CA3AF';
                        const fontWeight = isCurrent ? 'font-semibold' : 'font-medium';

                        return (
                            <div key={step.id} className="d-flex flex-column align-items-center position-relative"
                                style={{ zIndex: 3, width: `${100 / steps.length}%` }}>
                                {/* Step indicator */}
                                <div className="position-relative mb-1">
                                    <div className="step-shadow"
                                        style={{
                                            position: 'absolute',
                                            width: '32px',
                                            height: '32px',
                                            borderRadius: '50%',
                                            top: '-3px',
                                            left: '-3px',
                                            backgroundColor: isActive ? `${step.color}20` : 'transparent',
                                            zIndex: 0
                                        }}>
                                    </div>
                                    <div className={`d-flex align-items-center justify-content-center rounded-circle ${isCurrent ? 'glowing' : ''}`}
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            backgroundColor: stepColor,
                                            border: isCurrent ? `2px solid ${step.color}` : 'none',
                                            transition: 'all 0.3s ease',
                                            position: 'relative',
                                            zIndex: 1
                                        }}>
                                        {isActive ?
                                            (isCurrent ? step.activeIcon : step.completedIcon) :
                                            React.cloneElement(step.icon, { className: "text-gray-400" })
                                        }
                                    </div>
                                </div>

                                {/* Step label */}
                                <div className={`text-center ${fontWeight}`}
                                    style={{
                                        fontSize: '9px',
                                        color: textColor,
                                        transition: 'all 0.3s ease',
                                        lineHeight: '1.2',
                                        maxWidth: '68px',
                                        wordBreak: 'break-word'
                                    }}>
                                    {step.name}
                                </div>

                                {/* Status indicator */}
                                {isCurrent && (
                                    <div className="text-center mt-0.5"
                                        style={{
                                            fontSize: '8px',
                                            color: step.color,
                                            animation: 'fadeInOut 2s infinite'
                                        }}>

                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                <style jsx>{`
        @keyframes pulse {
            0% {
                box-shadow: 0 0 0 0 rgba(59, 130, 246, 0.4);
            }
            70% {
                box-shadow: 0 0 0 6px rgba(59, 130, 246, 0);
            }
            100% {
                box-shadow: 0 0 0 0 rgba(59, 130, 246, 0);
            }
        }
        
        @keyframes fadeInOut {
            0%, 100% { opacity: 0.8; }
            50% { opacity: 1; }
        }
        
        .glowing {
            animation: pulse 2s infinite;
        }
    `}</style>
            </div>
        );
    };






    const gettoDiscountAmount = orderData?.gettoDiscountAmount;
    const perOrderGettoDiscountAmount = orderData?.orderProducts?.[0]?.gettoDiscountedAmount;
    const amountToShowForGettoDiscount = orderData?.orderType == 1 ? perOrderGettoDiscountAmount : gettoDiscountAmount;



    const isOnlinePaymentPending = orderData?.paymentMode === 'ONLINE' && orderData?.paymentStatus === 'PENDING';
    const commission = (orderData?.orderProducts?.[0]?.Product?.manufacturer?.commission || 0);
    const billingAmount = orderData?.billingAmount || 0;
    const productQuantity = orderData?.orderProducts?.[0]?.quantity || 0;

    const amountPaidByCustomer = billingAmount - gettoDiscountAmount;
    const amountRefundedToCustomer = ((orderData?.orderProducts?.[0]?.originalDiscountedAmount * productQuantity) - orderData?.orderProducts?.[0]?.gettoDiscountedAmount);

    const amountToShowForCustomer = orderData?.orderType == 1 ? amountRefundedToCustomer : amountPaidByCustomer;


    const commissionAmount = Math.round(commission > 0 ? (billingAmount * commission) / 100 : 0);
    const total = billingAmount - commissionAmount;


    return (



        <>
            <style>{customStyles}</style>
            <style>{`
                /* ===== OrderDetails: font-size reductions + responsive layout (no color/design changes) ===== */
                .order_details_wrapper h1 { font-size: 20px !important; }
                .order_details_wrapper h2 { font-size: 18px !important; }
                .order_details_wrapper h3 { font-size: 16px !important; }
                .order_details_wrapper h4 { font-size: 13px !important; line-height: 1.35 !important; }
                .order_details_wrapper h5 { font-size: 12px !important; font-weight: 700 !important; }
                .order_details_wrapper h6 { font-size: 11px !important; }
                .order_details_wrapper p { font-size: 11px !important; margin-bottom: 6px; }
                .order_details_wrapper small,
                .order_details_wrapper .small { font-size: 10px !important; }
                .order_details_wrapper .btn { font-size: 11px !important; padding: 6px 12px !important; }
                .order_details_wrapper .btn-sm { font-size: 10px !important; padding: 4px 8px !important; }
                .order_details_wrapper .custom-rounded-btn { font-size: 11px !important; padding: 5px 12px !important; }
                .order_details_wrapper .badge { font-size: 10px !important; padding: 3px 7px !important; }
                .order_details_wrapper .text-muted { font-size: 11px !important; }
                .order_details_wrapper .card-title { font-size: 13px !important; font-weight: 700 !important; }
                .order_details_wrapper .modal-title { font-size: 15px !important; }
                .order_details_wrapper .modal-title h4 { font-size: 15px !important; }
                .order_details_wrapper label,
                .order_details_wrapper .form-label { font-size: 11px !important; margin-bottom: 4px !important; }
                .order_details_wrapper .form-control,
                .order_details_wrapper .form-select { font-size: 11px !important; padding: 6px 10px !important; min-height: 32px; }
                .order_details_wrapper .form-control::placeholder { font-size: 11px; }
                .order_details_wrapper .table { font-size: 11px !important; }
                .order_details_wrapper .table th,
                .order_details_wrapper .table td { font-size: 11px !important; padding: 8px 10px !important; }
                .order_details_wrapper .list-group-item { font-size: 11px !important; padding: 8px 12px !important; }
                .order_details_wrapper .dropdown-menu { font-size: 11px !important; }
                .order_details_wrapper .dropdown-item { font-size: 11px !important; padding: 6px 12px !important; }
                .order_details_wrapper .nav-link { font-size: 12px !important; }
                .order_details_wrapper input,
                .order_details_wrapper select,
                .order_details_wrapper textarea { font-size: 11px !important; }

                /* Card + table typography */
                .order_details_wrapper .card { border-radius: 4px !important; }
                .order_details_wrapper .card-body { padding: 14px !important; }
                .order_details_wrapper .custom-rounded-table th,
                .order_details_wrapper .custom-rounded-table td { font-size: 11px !important; padding: 8px 10px !important; }
                .order_details_wrapper .user-details-subheading { font-size: 11px !important; font-weight: 600; }
                .order_details_wrapper .user-details-data { font-size: 11px !important; }
                .order_details_wrapper .user-details-address { font-size: 11px !important; line-height: 1.4; }

                /* Order totals — reduce large amounts */
                .order_details_wrapper .order-otp { font-size: 13px !important; font-weight: 700; }

                /* Hide the global topbar on this page — the page header replaces it */
                body:has(.order_details_wrapper) #page-topbar { display: none !important; }
                body:has(.order_details_wrapper) .page-content {
                    padding-top: 0 !important;
                    padding-bottom: 24px !important;
                }

                /* Page header pinned at the top, full-width beyond the sidebar */
                /* Base page — soft neutral background, matches other admin pages */
                .order_details_wrapper {
                    background: #f9fafb;
                    min-height: calc(100vh - 70px);
                    padding-top: 78px !important;
                }
                .main-content:has(.order_details_wrapper) { background: #f9fafb; }
                .page-content:has(.order_details_wrapper) { background: #f9fafb; }

                .order_details_wrapper .page-header-sticky {
                    position: fixed !important;
                    top: 0 !important;
                    left: var(--vz-vertical-menu-width, 208px) !important;
                    right: 0 !important;
                    width: auto !important;
                    padding: clamp(14px, 1.6vw, 24px) clamp(14px, 1.4vw, 20px) clamp(10px, 1.2vw, 18px) !important;
                    margin: 0 !important;
                    background: #f9fafb !important;
                    border-bottom: 1px solid #eef2f7 !important;
                    z-index: 1030 !important;
                    box-shadow: none !important;
                }
                .order_details_wrapper .page-header-sticky h3 {
                    font-size: 18px !important;
                    font-weight: 700 !important;
                    color: #111827 !important;
                    letter-spacing: -0.01em !important;
                    margin: 0 !important;
                }
                body.modal-open .order_details_wrapper .page-header-sticky { z-index: 1030 !important; }

                /* Cards — consistent border, radius, subtle shadow */
                .order_details_wrapper .card {
                    border: none !important;
                    border-radius: 4px !important;
                    box-shadow: none !important;
                    margin-bottom: 12px !important;
                    overflow: hidden;
                }
                .order_details_wrapper .card-header {
                    background: transparent !important;
                    border-bottom: none !important;
                    padding: 10px 14px !important;
                }
                .order_details_wrapper .card-body { padding: 12px 14px !important; }
                .order_details_wrapper .order-id-related-links { display: none; }
                .order_details_wrapper .related-orders-section .card-body {
                    display: flex;
                    align-items: center;
                    gap: 16px;
                    padding: 14px !important;
                }
                .order_details_wrapper .related-orders-section .card-body > .card-title {
                    flex: 0 0 auto;
                    margin: 0 !important;
                    padding: 0 !important;
                    background: transparent !important;
                    white-space: nowrap;
                }
                .order_details_wrapper .related-orders-list {
                    display: grid;
                    gap: 7px;
                    flex: 1;
                }
                .order_details_wrapper .related-order-row {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 6px;
                    font-size: 12px;
                    color: #475569;
                }
                .order_details_wrapper .related-order-label {
                    font-weight: 600;
                    color: #64748b;
                }
                .order_details_wrapper .related-order-ids {
                    display: inline-flex;
                    flex-wrap: wrap;
                    gap: 4px;
                }
                .order_details_wrapper .related-order-id {
                    padding: 0;
                    border: none;
                    background: transparent;
                    color: #0f766e;
                    font-size: 12px;
                    font-weight: 600;
                    cursor: pointer;
                    text-decoration: underline;
                    text-underline-offset: 2px;
                }
                .order_details_wrapper .related-order-id:hover { color: #115e59; }
                .order_details_wrapper .related-order-row-return .related-order-id {
                    color: #b91c1c;
                }
                .order_details_wrapper .related-order-row-return .related-order-id:hover { color: #991b1b; }
                .order_details_wrapper .related-order-row-exchange .related-order-id {
                    color: #6d28d9;
                }
                .order_details_wrapper .related-order-row-exchange .related-order-id:hover { color: #5b21b6; }
                .order_details_wrapper .card-body > .card-title {
                    display: block;
                    background: transparent;
                    border-bottom: none;
                    margin: -12px -14px 12px !important;
                    padding: 8px 12px;
                }
                .order_details_wrapper .card-body > .d-flex:has(> .card-title) {
                    background: transparent;
                    border-bottom: none;
                    margin: -12px -14px 12px !important;
                    padding: 8px 12px;
                }

                /* First section — transparent shell so it feels like a page header block */
                .order_details_wrapper .od-first-section {
                    background: #fff !important;
                    border: none !important;
                    box-shadow: none !important;
                    padding: 0 !important;
                }
                .order_details_wrapper .od-first-section > .card-body { padding: 0 !important; background: #fff !important; }

                /* Order ID display — Sora */
                .order_details_wrapper .od-order-id {
                    font-family: 'Sora', ui-sans-serif, system-ui, sans-serif !important;
                    font-size: 20px !important;
                    font-weight: 700 !important;
                    color: #0f172a !important;
                    letter-spacing: -0.02em !important;
                    margin: 0 16px 0 0 !important;
                    font-variant-numeric: tabular-nums;
                }
                @media (max-width: 767.98px) {
                    .order_details_wrapper .od-order-id { font-size: 12px !important; letter-spacing: -0.015em !important; }
                    .order_details_wrapper .od-header-chip {
                        font-size: 9px !important;
                        padding: 2px 6px !important;
                        letter-spacing: 0.02em !important;
                    }
                    .order_details_wrapper .od-first-section {
                        margin-bottom: 10px !important;
                        margin-left: 0 !important;
                        margin-right: 0 !important;
                        background: #fff !important;
                    }
                    .order_details_wrapper .od-first-section > .card-body {
                        padding: 12px 16px !important;
                        background: #fff !important;
                    }
                    .order_details_wrapper .od-first-section > .card-body > .d-flex:first-child {
                        margin-bottom: 10px !important;
                    }
                }

                /* Back button styling */
                .order_details_wrapper .od-back-btn {
                    display: inline-flex; align-items: center; justify-content: center;
                    width: 30px; height: 30px; border-radius: 4px;
                    font-size: 16px; color: #475569; background: #fff;
                    border: 1px solid #e2e8f0; cursor: pointer;
                    margin-right: 8px; flex-shrink: 0;
                    transition: all 0.15s ease;
                }
                .order_details_wrapper .od-back-btn:hover { color: #008695; border-color: #008695; }

                /* Refresh & invoice buttons trimmed */
                .order_details_wrapper .page-header-sticky button.btn {
                    padding: 6px 12px !important;
                    font-size: 12px !important;
                }
                .order_details_wrapper .page-header-sticky button.btn svg { width: 14px; height: 14px; }

                /* Tables scroll on narrow viewports */
                .order_details_wrapper .table-responsive { overflow-x: auto; -webkit-overflow-scrolling: touch; }
                .order_details_wrapper .custom-rounded-table { min-width: 320px; }

                /* Desktop: hide the legacy in-card action row + OTP wrap — Next Step section owns these */
                @media (min-width: 768px) {
                    .order_details_wrapper .order-actions-row { display: none !important; }
                    .order_details_wrapper .order-otp-wrap { display: none !important; }
                }
                /* Mobile: legacy fixed action row + OTP wrap all hidden — Next Step section is the only fixed bottom bar.
                   Uses body-prefixed selector so it outranks the existing display:block/fixed rules
                   that live further down in the same stylesheet. */
                @media (max-width: 767.98px) {
                    body .order_details_wrapper .order-actions-row,
                    body .order_details_wrapper .order-actions-bar,
                    body .order_details_wrapper .order-otp-wrap,
                    body .order_details_wrapper .otp-mobile-block { display: none !important; }
                }

                /* Next Step call-to-action block */
                .order_details_wrapper .od-next-step {
                    position: relative;
                    overflow: hidden;
                    background: linear-gradient(135deg, #ecfeff 0%, #f0fdfa 55%, #ffffff 100%);
                    border: none;
                    border-radius: 12px;
                    padding: 14px 16px;
                    margin: 0 0 12px;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    box-shadow: 0 4px 14px rgba(0,134,149,0.08);
                }
                .order_details_wrapper .od-next-step::before {
                    content: '';
                    position: absolute;
                    inset: 0 auto 0 0;
                    width: 3px;
                    background: #008695;
                }
                .order_details_wrapper .od-next-step::after {
                    content: '';
                    position: absolute;
                    top: -120%;
                    left: -25%;
                    width: 28%;
                    height: 340%;
                    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
                    transform: rotate(20deg);
                    animation: od-next-step-shimmer 4s ease-in-out infinite;
                    pointer-events: none;
                }
                @keyframes od-next-step-shimmer {
                    0%, 55% { transform: translateX(0) rotate(20deg); opacity: 0; }
                    65% { opacity: 1; }
                    100% { transform: translateX(500%) rotate(20deg); opacity: 0; }
                }
                .order_details_wrapper .od-next-step-head { flex: 1; min-width: 0; }
                .order_details_wrapper .od-next-step-badge {
                    display: inline-flex;
                    align-items: center;
                    gap: 5px;
                    padding: 2px 8px;
                    background: #008695;
                    color: #fff;
                    font-size: 10px;
                    font-weight: 700;
                    letter-spacing: 0.04em;
                    text-transform: uppercase;
                    border-radius: 999px;
                    margin-bottom: 6px;
                }
                .order_details_wrapper .od-live-dot {
                    width: 6px;
                    height: 6px;
                    border-radius: 50%;
                    background: #a7f3d0;
                    box-shadow: 0 0 0 0 rgba(167,243,208,0.7);
                    animation: od-live-pulse 1.8s ease-out infinite;
                }
                @keyframes od-live-pulse {
                    70% { box-shadow: 0 0 0 5px rgba(167,243,208,0); }
                    100% { box-shadow: 0 0 0 0 rgba(167,243,208,0); }
                }
                @media (prefers-reduced-motion: reduce) {
                    .order_details_wrapper .od-next-step::after,
                    .order_details_wrapper .od-live-dot { animation: none; }
                }
                .order_details_wrapper .od-next-step-title {
                    font-size: 13px;
                    color: #0f172a;
                    font-weight: 600;
                    line-height: 1.4;
                }
                .order_details_wrapper .od-next-step-otp {
                    display: inline-flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 5px;
                    padding: 8px 12px;
                    background: #fff;
                    border: 1px solid rgba(0,134,149,0.22);
                    border-radius: 10px;
                }
                .order_details_wrapper .od-next-step-otp-label {
                    font-size: 9px;
                    font-weight: 700;
                    color: #008695;
                    text-transform: uppercase;
                    letter-spacing: 0.06em;
                }
                .order_details_wrapper .od-next-step-otp-digits {
                    display: flex;
                    gap: 4px;
                }
                .order_details_wrapper .od-next-step-actions {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    flex-shrink: 0;
                }
                .order_details_wrapper .od-ns-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 0 14px;
                    height: 36px;
                    border-radius: 6px;
                    font-size: 12.5px;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    white-space: nowrap;
                    border: 1px solid transparent;
                }
                .order_details_wrapper .od-ns-btn:disabled { opacity: 0.55; cursor: not-allowed; }
                .order_details_wrapper .od-ns-btn-secondary {
                    background: #fff;
                    border-color: #cbd5e1;
                    color: #0f172a;
                }
                .order_details_wrapper .od-ns-btn-secondary:hover:not(:disabled) {
                    background: #f8fafc; border-color: #94a3b8;
                }
                .order_details_wrapper .od-ns-btn-confirm {
                    background: #16a34a; border-color: #16a34a; color: #fff;
                    box-shadow: 0 3px 8px rgba(22,163,74,0.22);
                }
                .order_details_wrapper .od-ns-btn-confirm:hover:not(:disabled) {
                    background: #15803d; border-color: #15803d;
                }
                .order_details_wrapper .od-ns-btn-reject {
                    background: #dc2626; border-color: #dc2626; color: #fff;
                    box-shadow: 0 3px 8px rgba(220,38,38,0.22);
                }
                .order_details_wrapper .od-ns-btn-reject:hover:not(:disabled) {
                    background: #b91c1c; border-color: #b91c1c;
                }
                .order_details_wrapper .od-ns-btn-evidence {
                    background: #0e7490; border-color: #0e7490; color: #fff;
                    box-shadow: 0 3px 8px rgba(14,116,144,0.24);
                }
                .order_details_wrapper .od-ns-btn-evidence:hover:not(:disabled) {
                    background: #155e75; border-color: #155e75;
                }
                .order_details_wrapper .od-ns-btn-evidence svg { flex-shrink: 0; }
                @media (max-width: 767.98px) {
                    /* Fixed bottom action bar: controls only, without descriptive copy. */
                    .order_details_wrapper .od-next-step {
                        position: fixed;
                        left: 0; right: 0; bottom: 0;
                        margin: 0;
                        padding: 12px 14px calc(12px + env(safe-area-inset-bottom, 0px));
                        border-radius: 14px 14px 0 0;
                        border-left: none;
                        border-right: none;
                        border-bottom: none;
                        background: #f3f4f6;
                        border-top: 1px solid #e5e7eb;
                        box-shadow: none;
                        z-index: 1049;
                        flex-direction: column;
                        align-items: stretch;
                        gap: 10px;
                    }
                    .order_details_wrapper .od-next-step::before,
                    .order_details_wrapper .od-next-step::after { display: none; }
                    /* The mobile bar intentionally contains only OTP digits or actions. */
                    .order_details_wrapper .od-next-step-head {
                        display: none !important;
                    }
                    .order_details_wrapper .od-next-step-badge { display: none !important; }

                    /* Big prominent OTP row — label + digits, both centered horizontally */
                    .order_details_wrapper .od-next-step-otp {
                        flex-direction: row;
                        align-items: center;
                        justify-content: center;
                        padding: 10px 12px;
                        width: 100%;
                        gap: 12px;
                    }
                    .order_details_wrapper .od-next-step-otp-label { display: none !important; }
                    .order_details_wrapper .od-next-step-otp-digits {
                        display: flex;
                        justify-content: center;
                        gap: 8px;
                        flex-shrink: 0;
                    }
                    /* Override the shared .order-otp digit style just inside the Next Step bar */
                    .order_details_wrapper .od-next-step-otp .order-otp {
                        width: 40px !important;
                        height: 48px !important;
                        font-size: 22px !important;
                        font-weight: 800 !important;
                        border-radius: 8px !important;
                        border: 1px solid #cbd5e1 !important;
                        background: #f8fafc !important;
                        color: #0f172a !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        margin: 0 !important;
                        padding: 0 !important;
                        font-family: 'Sora', ui-sans-serif, system-ui, sans-serif !important;
                        font-variant-numeric: tabular-nums;
                    }

                    /* Big prominent action buttons */
                    .order_details_wrapper .od-next-step-actions {
                        display: flex;
                        gap: 8px;
                    }
                    .order_details_wrapper .od-ns-btn {
                        flex: 1 1 0;
                        height: 46px;
                        font-size: 13.5px;
                        border-radius: 8px;
                    }
                    .order_details_wrapper .od-ns-btn-confirm {
                        background: #166534;
                        border-color: #166534;
                        color: #fff;
                        box-shadow: none;
                    }
                    .order_details_wrapper .od-ns-btn-reject {
                        background: #991b1b;
                        border-color: #991b1b;
                        color: #fff;
                        box-shadow: none;
                    }
                    .order_details_wrapper .od-ns-btn-evidence {
                        background: #0e7490;
                        border-color: #0e7490;
                        color: #fff;
                        height: 50px;
                        font-size: 14px;
                        font-weight: 700;
                        letter-spacing: 0.01em;
                        border-radius: 10px;
                        box-shadow: 0 4px 12px rgba(14,116,144,0.28);
                        gap: 8px;
                    }
                    .order_details_wrapper .od-ns-btn-evidence svg { width: 18px; height: 18px; }
                }

                /* Order tracker — white card with subtle border */
                .order_details_wrapper .order-tracker-container {
                    background: #fff !important;
                    border: none !important;
                    border-radius: 4px !important;
                    box-shadow: none !important;
                    padding: 12px 16px !important;
                }

                @media (min-width: 768px) {
                    .order_details_wrapper .card,
                    .order_details_wrapper .od-first-section,
                    .order_details_wrapper .order-tracker-container {
                        border-radius: 12px !important;
                    }
                    .order_details_wrapper .od-first-section > .card-body {
                        padding: 16px 14px !important;
                    }
                    .order_details_wrapper .od-first-section > .card-body > .d-flex:first-child {
                        align-items: center !important;
                        margin-bottom: 0 !important;
                    }
                    .order_details_wrapper .order-tracker-container {
                        padding: 20px 16px 16px !important;
                    }
                    .order_details_wrapper .order-tracker-container > .d-flex {
                        align-items: center;
                    }
                    .order_details_wrapper .row {
                        --bs-gutter-x: 12px;
                        --bs-gutter-y: 12px;
                    }
                    .order_details_wrapper .row > [class*="col-"] {
                        margin-bottom: 0 !important;
                    }
                    .order_details_wrapper .row > [class*="col-"] > .card {
                        margin-bottom: 0 !important;
                    }
                    .order_details_wrapper .order-tracker-container {
                        margin-bottom: 12px !important;
                    }
                }

                /* OTP subheading — hidden on desktop */
                .order_details_wrapper .otp-subheading { display: none; }

                /* Confirm / Reject action buttons — centered content + icon */
                .order_details_wrapper .action-btn {
                    display: inline-flex !important;
                    align-items: center !important;
                    justify-content: center !important;
                    gap: 6px;
                    padding: 9px 18px !important;
                    border-radius: 6px !important;
                    font-weight: 600 !important;
                    transition: all 0.15s ease !important;
                }
                .order_details_wrapper .action-btn-icon {
                    width: 14px; height: 14px;
                    flex-shrink: 0;
                }
                /* Confirm — solid green */
                .order_details_wrapper .action-btn-confirm {
                    background: #16a34a !important;
                    border: 1px solid #16a34a !important;
                    color: #fff !important;
                    box-shadow: 0 3px 8px rgba(22,163,74,0.22);
                }
                .order_details_wrapper .action-btn-confirm:hover:not(:disabled) {
                    background: #15803d !important;
                    border-color: #15803d !important;
                    color: #fff !important;
                }
                .order_details_wrapper .action-btn-confirm:disabled {
                    background: #16a34a !important;
                    border-color: #16a34a !important;
                    color: #fff !important;
                    opacity: 0.55;
                }
                /* Reject — solid red */
                .order_details_wrapper .action-btn-reject {
                    background: #dc2626 !important;
                    border: 1px solid #dc2626 !important;
                    color: #fff !important;
                    box-shadow: 0 3px 8px rgba(220,38,38,0.22);
                }
                .order_details_wrapper .action-btn-reject:hover:not(:disabled) {
                    background: #b91c1c !important;
                    border-color: #b91c1c !important;
                    color: #fff !important;
                }
                .order_details_wrapper .action-btn-reject:disabled {
                    background: #dc2626 !important;
                    border-color: #dc2626 !important;
                    color: #fff !important;
                    opacity: 0.55;
                }

                @media (max-width: 767.98px) {
                    /* Make the timeline horizontally scrollable, tighter steps */
                    .order_details_wrapper .order-tracker-container {
                        padding: 12px 16px !important;
                        overflow-x: auto;
                        overflow-y: visible;
                        -webkit-overflow-scrolling: touch;
                        scrollbar-width: none;
                    }
                    .order_details_wrapper .order-tracker-container::-webkit-scrollbar { display: none; }
                    /* Force horizontal layout with fixed step widths so nothing compresses */
                    .order_details_wrapper .order-tracker-container > .d-flex {
                        justify-content: flex-start !important;
                        padding: 0;
                        min-width: max-content;
                    }
                    .order_details_wrapper .order-tracker-container > .d-flex > div {
                        width: 60px !important;
                        min-width: 60px !important;
                        flex-shrink: 0;
                    }
                    /* Shrink the step circle further */
                    .order_details_wrapper .order-tracker-container .rounded-circle {
                        width: 22px !important;
                        height: 22px !important;
                    }
                    /* Shrink shadow ring proportionally */
                    .order_details_wrapper .order-tracker-container .step-shadow {
                        width: 26px !important;
                        height: 26px !important;
                        top: -2px !important;
                        left: -2px !important;
                    }
                    /* Shrink icons inside step circles */
                    .order_details_wrapper .order-tracker-container .rounded-circle svg {
                        width: 8px !important;
                        height: 8px !important;
                    }
                    /* Progress line aligns with smaller circle center */
                    .order_details_wrapper .order-tracker-container .progress-line {
                        top: 10px !important;
                        left: 42px !important;
                        right: 42px !important;
                    }
                    /* Tiny label text */
                    .order_details_wrapper .order-tracker-container > .d-flex > div > .text-center {
                        font-size: 8px !important;
                        max-width: 58px !important;
                        line-height: 1.2 !important;
                    }
                }

                /* Responsive breakpoints */
                @media (max-width: 991.98px) {
                    .order_details_wrapper .page-header-sticky { padding: 16px 20px !important; }
                    .order_details_wrapper .card-body { padding: 12px !important; }
                }
                /* Mobile-only invoice bar (hidden on desktop) — NOTE: this bar lives outside
                   .order_details_wrapper so selectors must not require it as ancestor */
                .od-invoice-bar { display: none; }

                @media (max-width: 767.98px) {
                    body:has(.order_details_wrapper) .mobile-topbar { display: none !important; }
                    body:has(.order_details_wrapper) .main-content { padding-top: 0 !important; }
                    body:has(.order_details_wrapper) .page-content {
                        padding-left: 0 !important;
                        padding-right: 0 !important;
                    }
                    body:has(.order_details_wrapper) .container,
                    body:has(.order_details_wrapper) .container-fluid {
                        padding-left: 0 !important;
                        padding-right: 0 !important;
                    }
                    .order_details_wrapper .page-header-sticky {
                        left: 0 !important;
                        right: 0 !important;
                        padding: 12px 10px !important;
                        gap: 8px !important;
                        flex-wrap: nowrap !important;
                    }
                    .order_details_wrapper .page-header-sticky h3 { font-size: 15px !important; }
                    .order_details_wrapper { padding-top: 40px !important; padding-bottom: 200px !important; }
                    .order_details_wrapper .card { border-radius: 0 !important; margin-bottom: 10px !important; }
                    .order_details_wrapper .card-body { padding: 12px 16px !important; }
                    .order_details_wrapper .related-orders-section .card-body {
                        display: block;
                        padding: 12px 16px !important;
                    }
                    .order_details_wrapper .related-orders-section .card-body > .card-title {
                        margin-bottom: 10px !important;
                    }
                    .order_details_wrapper .related-orders-list { gap: 7px; }
                    .order_details_wrapper .card-header { padding: 12px 16px !important; }
                    .order_details_wrapper .card-body > .card-title,
                    .order_details_wrapper .card-body > .d-flex:has(> .card-title) {
                        margin: -12px -16px 12px !important;
                    }
                    .order_details_wrapper .row { --bs-gutter-x: 0; }
                    .order_details_wrapper .row > [class*="col-"] {
                        padding-left: 0 !important;
                        padding-right: 0 !important;
                        margin-bottom: 10px !important;
                    }
                    .order_details_wrapper .row > [class*="col-"] > .card {
                        margin-bottom: 0 !important;
                    }
                    .order_details_wrapper > .row > .mt-0 { padding-left: 0; padding-right: 0; }
                    /* Timeline: white card with round border + symmetric padding */
                    .order_details_wrapper .order-tracker-container {
                        background: #fff !important;
                        border: none !important;
                        border-radius: 0 !important;
                        box-shadow: none !important;
                        padding: 12px 16px !important;
                        margin: 0 0 10px !important;
                    }

                    /* Header: hide the two invoice buttons + collapse Refresh to icon-only */
                    .order_details_wrapper .od-header-actions .od-invoice-btn { display: none !important; }
                    .order_details_wrapper .od-header-actions .od-refresh-btn {
                        padding: 6px 8px !important;
                        min-width: 34px;
                        justify-content: center;
                    }
                    .order_details_wrapper .od-header-actions .od-refresh-label { display: none !important; }

                    /* Fixed bottom invoice bar (outside wrapper — global selector) */
                    .od-invoice-bar {
                        display: flex !important;
                        position: fixed !important;
                        left: 0 !important;
                        right: 0 !important;
                        bottom: 0 !important;
                        padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px)) !important;
                        background: #fff !important;
                        border-top: 1px solid #e2e8f0 !important;
                        box-shadow: 0 -2px 8px rgba(15,23,42,0.05) !important;
                        gap: 10px !important;
                        z-index: 1050 !important;
                    }
                    .od-invoice-btn-m {
                        flex: 1 1 0;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        gap: 6px;
                        height: 44px;
                        padding: 0 12px;
                        font-size: 12px;
                        font-weight: 600;
                        color: #0f172a;
                        background: #fff;
                        border: 1px solid #e2e8f0;
                        border-radius: 6px;
                        cursor: pointer;
                        transition: all 0.15s ease;
                    }
                    .od-invoice-btn-m:hover:not(:disabled) {
                        border-color: #008695; color: #008695; background: rgba(0,134,149,0.06);
                    }
                    .od-invoice-btn-m-primary {
                        background: #008695;
                        border-color: #008695;
                        color: #fff;
                    }
                    .od-invoice-btn-m-primary:hover:not(:disabled) {
                        background: #006672; border-color: #006672; color: #fff;
                    }
                    .od-invoice-btn-m:disabled { opacity: 0.6; cursor: not-allowed; }

                    /* Fixed OTP bar at the bottom, above the actions bar */
                    .order_details_wrapper .otp-mobile-block {
                        position: fixed !important;
                        left: 0 !important;
                        right: 0 !important;
                        bottom: 68px !important;
                        margin: 0 !important;
                        padding: 16px 16px 18px !important;
                        background: linear-gradient(180deg, #f0fdfa 0%, #ffffff 100%) !important;
                        border-top: 1px solid #ccfbf1 !important;
                        flex-direction: column !important;
                        justify-content: center !important;
                        align-items: center !important;
                        gap: 12px !important;
                        z-index: 1049;
                        box-shadow: 0 -4px 12px rgba(15,23,42,0.06);
                    }
                    /* Heading + subheading stack */
                    .order_details_wrapper .otp-mobile-block .otp-heading-block {
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        gap: 2px;
                    }
                    .order_details_wrapper .otp-mobile-block .otp-label {
                        font-size: 15px !important;
                        font-weight: 700 !important;
                        color: #0f172a !important;
                        margin: 0 !important;
                        letter-spacing: -0.01em;
                    }
                    .order_details_wrapper .otp-mobile-block .otp-subheading {
                        display: block !important;
                        font-size: 11px !important;
                        color: #475569 !important;
                        font-weight: 500;
                        margin: 0;
                    }
                    /* Big centered OTP digits */
                    .order_details_wrapper .otp-mobile-block .otp-container {
                        justify-content: center !important;
                        gap: 8px !important;
                        margin: 0 !important;
                    }
                    .order_details_wrapper .otp-mobile-block .order-otp {
                        font-size: 28px !important;
                        font-weight: 800 !important;
                        color: #0f172a !important;
                        min-width: 44px !important;
                        height: 52px !important;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        padding: 0 !important;
                        margin: 0 !important;
                        border-radius: 8px !important;
                        background: #ffffff !important;
                        border: 1.5px solid #008695 !important;
                        box-shadow: 0 2px 6px rgba(0,134,149,0.15);
                    }
                    /* If no actions bar present, drop OTP to bottom edge */
                    .order_details_wrapper:not(:has(.order-actions-bar .btn)) .otp-mobile-block {
                        bottom: 0 !important;
                        padding-bottom: calc(18px + env(safe-area-inset-bottom, 0px)) !important;
                    }

                    /* Fixed action bar (Confirm / Reject) at the bottom */
                    .order_details_wrapper .order-actions-row {
                        display: block !important;
                    }
                    .order_details_wrapper .order-actions-row > div:first-child { display: none; }
                    .order_details_wrapper .order-actions-bar:has(.btn) {
                        position: fixed !important;
                        left: 0 !important;
                        right: 0 !important;
                        bottom: 0 !important;
                        margin: 0 !important;
                        padding: 10px 14px calc(10px + env(safe-area-inset-bottom, 0px)) !important;
                        background: #fff !important;
                        border-top: 1px solid #e2e8f0 !important;
                        gap: 10px !important;
                        z-index: 1050;
                        justify-content: stretch !important;
                        box-shadow: 0 -2px 8px rgba(15,23,42,0.05);
                    }
                    .order_details_wrapper .order-actions-bar:has(.btn) > .btn {
                        flex: 1 1 0 !important;
                        height: auto !important;
                        padding: 12px 16px !important;
                        font-size: 13px !important;
                        font-weight: 700 !important;
                        border-radius: 6px !important;
                        display: inline-flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        gap: 6px;
                    }
                    .order_details_wrapper .order-actions-bar .action-btn-icon {
                        width: 16px; height: 16px;
                    }
                    .order_details_wrapper .page-header-sticky h3 { font-size: 15px !important; }
                    /* Compact header actions on mobile */
                    .order_details_wrapper .page-header-sticky button.btn {
                        padding: 5px 10px !important;
                        font-size: 11px !important;
                    }
                    .order_details_wrapper .card-body { padding: 10px !important; }
                    /* Stack Bootstrap grid cols */
                    .order_details_wrapper .row > [class*="col-md-"],
                    .order_details_wrapper .row > [class*="col-lg-"] {
                        flex: 0 0 100%;
                        max-width: 100%;
                    }
                    /* Any right-aligned column block should wrap on mobile */
                    .order_details_wrapper .d-flex.justify-content-between.align-items-start,
                    .order_details_wrapper .d-flex.justify-content-between {
                        flex-wrap: wrap !important;
                        gap: 10px !important;
                    }
                    .order_details_wrapper .d-flex.flex-column.align-items-end {
                        align-items: flex-start !important;
                        width: 100%;
                    }
                    /* Prevent tables from breaking layout */
                    .order_details_wrapper table.table {
                        display: block;
                        overflow-x: auto;
                        white-space: nowrap;
                    }
                    .order_details_wrapper .custom-rounded-table td,
                    .order_details_wrapper .custom-rounded-table th {
                        white-space: normal;
                        padding: 6px 8px !important;
                    }
                    /* Product images shrink */
                    .order_details_wrapper .order-product-image { max-width: 80px !important; height: auto !important; }
                    /* OTP boxes tighter */
                    .order_details_wrapper .order-otp {
                        width: 26px !important; height: 32px !important;
                        font-size: 12px !important;
                    }
                }
                @media (max-width: 480px) {
                    .order_details_wrapper .page-header-sticky h3 { font-size: 14px !important; }
                    .order_details_wrapper h4 { font-size: 13px !important; }
                    .order_details_wrapper .card-body { padding: 12px 16px !important; }
                }
            `}</style>
            <div className='order_details_wrapper'>
                {(
                    <>
                        <div className="page-header-sticky d-flex align-items-center justify-content-between flex-wrap gap-3">
                            <div className="d-flex align-items-center">
                                <button
                                    type="button"
                                    className="od-back-btn back-btn"
                                    onClick={() => navigate(-1)}
                                    aria-label="Back"
                                >
                                    <IoMdArrowBack />
                                </button>
                                <h3 className="mb-0 fw-bold">Order details</h3>
                            </div>

                            <div className="d-flex align-items-center gap-2 flex-wrap od-header-actions">
                                {orderData?.status === "DELIVERED" &&
                                    orderData?.orderType == null &&
                                    orderData?.returnId == null && (
                                        <>
                                            <Button
                                                variant="outline-primary"
                                                onClick={handleDownloadVendorInvoice}
                                                className="custom-rounded-btn od-invoice-btn"
                                            >
                                                {downloadVendorInvoice ? (
                                                    <>
                                                        <Spinner as="span" animation="border" size="sm" />
                                                        <span className="ms-2">downloading ...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaDownload /> Vendor invoice
                                                    </>
                                                )}
                                            </Button>

                                            <Button
                                                variant="outline-primary"
                                                onClick={handleDownloadCustomerInvoice}
                                                className="custom-rounded-btn od-invoice-btn"
                                            >
                                                {downloadCustomerInvoice ? (
                                                    <>
                                                        <Spinner as="span" animation="border" size="sm" />
                                                        <span className="ms-2">downloading ...</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <FaDownload /> Customer invoice
                                                    </>
                                                )}
                                            </Button>
                                        </>
                                    )
                                }

                                <button
                                    onClick={handleRefresh}
                                    className="btn border border-secondary bg-white rounded-3 d-inline-flex align-items-center gap-2 od-refresh-btn"
                                    style={{
                                        padding: '8px 14px',
                                        fontSize: '11px',
                                        color: '#374151',
                                    }}
                                    disabled={refreshing || loading}
                                    title="Refresh order details"
                                    aria-label="Refresh"
                                >
                                    <FiRefreshCw
                                        size={16}
                                        style={{
                                            transition: "transform 0.3s ease-in-out",
                                            transform: refreshing ? "rotate(360deg)" : "rotate(0deg)",
                                            animation: refreshing ? "spin 1s linear infinite" : "none"
                                        }}
                                    />
                                    <span className="od-refresh-label">
                                        {refreshing ? "Refreshing..." : "Refresh"}
                                    </span>
                                </button>
                            </div>
                        </div>

                        <div className="row">



                        {



                            loading ?

                                <div className='d-flex justify-content-center align-items-center' style={{ height: '400px' }}>
                                    <Loader />
                                </div>

                                :

                                error ? (
                                    <ErrorState onRetry={handleRefresh} />
                                ) :

                                    (<div className="mt-0">
                                        <div className="card custom-rounded-card mb-4 od-first-section">

                                            <div className="card-body">
                                                <div className='d-flex justify-content-between align-items-start mb-4'>
                                                    <div>
                                                        <div className="d-flex align-items-center flex-wrap" style={{ gap: 6 }}>
                                                            <h4 className="mb-0 od-order-id" style={{
                                                                lineHeight: 1.2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                marginRight: 16,
                                                            }}>
                                                                <span>{orderData?.orderId}</span>
                                                            </h4>

                                                            {orderData?.isScheduled && (
                                                                <span
                                                                    className="od-header-chip"
                                                                    style={{
                                                                        display: "inline-block",
                                                                        padding: "4px 10px 3px",
                                                                        fontSize: 11,
                                                                        fontWeight: 600,
                                                                        lineHeight: 1.2,
                                                                        letterSpacing: "0.03em",
                                                                        textTransform: "none",
                                                                        background: "#fef3c7",
                                                                        border: "1px solid #fde68a",
                                                                        borderRadius: 4,
                                                                        color: "#92400e",
                                                                        whiteSpace: "nowrap",
                                                                        textAlign: "center",
                                                                        verticalAlign: "middle",
                                                                    }}
                                                                >
                                                                    Scheduled
                                                                </span>
                                                            )}

                                                            {/* Order Type chip — same palette as the Orders page table */}
                                                            {(() => {
                                                                const t = orderData?.orderType;
                                                                const sfe = orderData?.statusForExchangeOrder;
                                                                let label;
                                                                if (t === 3) label = 'Delivered';
                                                                else if (t === 2) label = sfe === 1 ? 'EXCHANGE_RETURN' : sfe === 2 ? 'EXCHANGE_DELIVERY' : 'Exchange';
                                                                else if (t === 1) label = 'Return';
                                                                else label = 'New';
                                                                let bg = '#e0f2fe', color = '#0369a1';
                                                                if (t === 1) { bg = '#fee2e2'; color = '#b91c1c'; }
                                                                else if (t === 2) {
                                                                    if (sfe === 1) { bg = '#fef3c7'; color = '#92400e'; }
                                                                    else if (sfe === 2) { bg = '#dbeafe'; color = '#1d4ed8'; }
                                                                    else { bg = '#ede9fe'; color = '#6d28d9'; }
                                                                }
                                                                else if (t === 3) { bg = '#dcfce7'; color = '#166534'; }
                                                                return (
                                                                    <span
                                                                        className="od-header-chip"
                                                                        style={{
                                                                            display: 'inline-block',
                                                                            padding: '4px 10px 3px',
                                                                            fontSize: 11,
                                                                            fontWeight: 600,
                                                                            lineHeight: 1.2,
                                                                            letterSpacing: '0.03em',
                                                                            textTransform: 'uppercase',
                                                                            background: bg,
                                                                            color,
                                                                            border: 'none',
                                                                            borderRadius: 4,
                                                                            whiteSpace: 'nowrap',
                                                                            textAlign: 'center',
                                                                            verticalAlign: 'middle',
                                                                        }}
                                                                    >
                                                                        {label}
                                                                    </span>
                                                                );
                                                            })()}

                                                            {/* Status chip — same palette as the Orders page table */}
                                                            {(() => {
                                                                const s = orderData?.status;
                                                                const t = orderData?.orderType;
                                                                if (!s) return null;
                                                                let bg = '#334155', color = '#fff';
                                                                switch (s) {
                                                                    case 'CANCELLED': bg = '#dc2626'; color = '#fff'; break;
                                                                    case 'INITIATED': bg = '#facc15'; color = '#0f172a'; break;
                                                                    case 'CONFIRMED': bg = '#0e7490'; color = '#fff'; break;
                                                                    case 'DELIVERED': bg = '#10b981'; color = '#fff'; break;
                                                                    case 'REJECTED':  bg = '#dc2626'; color = '#fff'; break;
                                                                    default:          bg = '#6d28d9'; color = '#fff';
                                                                }
                                                                const toVendor = orderData?.statusForExchangeOrder === 1 && t === 2 && orderData?.orderStatus === 'DELIVERED' ? ' TO VENDOR' : '';
                                                                const pretty = s.toLowerCase().split('_').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
                                                                return (
                                                                    <span
                                                                        className="od-header-chip"
                                                                        style={{
                                                                            display: 'inline-block',
                                                                            padding: '4px 10px 3px',
                                                                            fontSize: 11,
                                                                            fontWeight: 600,
                                                                            lineHeight: 1.2,
                                                                            letterSpacing: '0.03em',
                                                                            textTransform: 'uppercase',
                                                                            background: bg,
                                                                            color,
                                                                            border: 'none',
                                                                            borderRadius: 4,
                                                                            whiteSpace: 'nowrap',
                                                                            textAlign: 'center',
                                                                            verticalAlign: 'middle',
                                                                        }}
                                                                    >
                                                                        {pretty}{toVendor}
                                                                    </span>
                                                                );
                                                            })()}
                                                        </div>

                                                        {/* Order date — sits directly under the Order ID row */}
                                                        <div
                                                            style={{
                                                                fontSize: 11,
                                                                fontWeight: 500,
                                                                color: "#64748b",
                                                                marginTop: 0,
                                                                lineHeight: 1.2,
                                                                whiteSpace: "nowrap",
                                                            }}
                                                        >
                                                            {moment(orderData?.createdAt).format('D MMM YYYY, h:mm a')}
                                                        </div>


                                                        <div className="order-id-related-links">
                                                        {orderData?.parentOrderId && (
                                                            <span
                                                                onClick={() => navigate('/orderdetails/' + orderData.parentOrderId)}
                                                                style={{
                                                                    fontSize: "12px",
                                                                    fontWeight: "700",
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    color: "#0b6fa5ff", // Bootstrap blue
                                                                    textDecoration: "underline"
                                                                }}
                                                            >
                                                                Check parent order → {orderData.parentOrderId}
                                                            </span>
                                                        )}

                                                        {/* Show Return Ids */}
                                                        {orderData?.returnIdForVedor && (
                                                            <>
                                                                <span

                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: "700",
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        color: "red",
                                                                        marginLeft: "5px",
                                                                    }}
                                                                >
                                                                    Check returned order →

                                                                </span>
                                                                {(
                                                                    typeof orderData.returnIdForVedor === 'string'
                                                                        ? orderData.returnIdForVedor.split(',').map(id => id.trim())
                                                                        : orderData.returnIdForVedor
                                                                ).map((id, index) => (
                                                                    <span
                                                                        key={`return-${id}-${index}`}
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            fontWeight: "700",
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            marginLeft: "10px",
                                                                            color: "red",
                                                                        }}
                                                                    >
                                                                        {' '}
                                                                        <span
                                                                            onClick={() => navigate('/orderdetails/' + id)}
                                                                            style={{
                                                                                cursor: "pointer",
                                                                                color: "red",
                                                                                textDecoration: "underline",
                                                                            }}
                                                                        >
                                                                            {id}
                                                                        </span>
                                                                    </span>
                                                                ))}
                                                            </>
                                                        )}


                                                        {/* Show Exchange Ids */}
                                                        {orderData?.exchangeIdForVedor && (
                                                            <>

                                                                <span

                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: "700",
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        marginLeft: "15px",

                                                                        color: "#0b6a93ff",
                                                                    }}
                                                                >
                                                                    Check exchanged order →

                                                                </span>
                                                                {(
                                                                    typeof orderData.exchangeIdForVedor === 'string'
                                                                        ? orderData.exchangeIdForVedor.split(',').map(id => id.trim())
                                                                        : orderData.exchangeIdForVedor
                                                                ).map((id, index) => (
                                                                    <span
                                                                        key={`exchange-${id}-${index}`}
                                                                        onClick={() => navigate('/orderdetails/' + id)}
                                                                        style={{
                                                                            fontSize: "12px",
                                                                            fontWeight: "700",
                                                                            display: "inline-flex",
                                                                            alignItems: "center",
                                                                            cursor: "pointer",
                                                                            color: "#0b6a93ff",
                                                                            textDecoration: "underline",
                                                                            marginLeft: "10px"
                                                                        }}
                                                                    >
                                                                        {id}
                                                                    </span>
                                                                ))}
                                                            </>
                                                        )}

                                                    </div>



                                                        </div>
                                                    <div className='d-flex flex-column align-items-end order-otp-wrap'>
                                                        {(() => {
                                                            const t = orderData?.orderType;
                                                            const sfe = orderData?.statusForExchangeOrder;
                                                            const s = orderData?.status;
                                                            const dStatus = orderData?.deliveryStatus;
                                                            const pickupOtp = orderData?.pidgeOrder?.pickupOtp;
                                                            const dropOtp = orderData?.pidgeOrder?.dropOtp;
                                                            const isExchange = t === 2;

                                                            const showPickupOtp = s === 'CONFIRMED' && !!pickupOtp && (
                                                                isExchange
                                                                    ? sfe === 2
                                                                    : ((t === null || t === undefined) && dStatus === 'PENDING')
                                                            );
                                                            const showDropOtp = s === 'CONFIRMED' && !!dropOtp && (
                                                                isExchange
                                                                    ? sfe === 1
                                                                    : (t === 1 && dStatus === 'DISPATCHED')
                                                            );

                                                            return (
                                                                <>
                                                                    {showPickupOtp && (
                                                                        <div className='d-flex align-items-center mb-2 otp-mobile-block'>
                                                                            <div className='otp-heading-block'>
                                                                                <h5 className="mb-0 otp-label">Pickup OTP</h5>
                                                                                <div className="otp-subheading">Share this OTP with the driver at pickup</div>
                                                                            </div>
                                                                            <div className='otp-container d-flex'>
                                                                                {renderOtpDigits(pickupOtp)}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {showDropOtp && (
                                                                        <div className='d-flex align-items-center mb-2 otp-mobile-block'>
                                                                            <div className='otp-heading-block'>
                                                                                <h5 className="mb-0 otp-label">Drop OTP</h5>
                                                                                <div className="otp-subheading">Share this OTP with the driver at delivery</div>
                                                                            </div>
                                                                            <div className='otp-container d-flex'>
                                                                                {renderOtpDigits(dropOtp)}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            );
                                                        })()}





                                                    </div>
                                                </div>

                                                <div className='d-flex justify-content-between align-items-center order-actions-row'>
                                                    <div></div>
                                                    <div className='d-flex gap-3 order-actions-bar'>

                                                        {(orderData?.status === 'INITIATED' && orderData?.orderType === null) && (
                                                            <>
                                                                <Button
                                                                    onClick={() => { setRejectionReason(''); setCustomReason(''); setShowRejectConfirm(true); }}
                                                                    className="custom-rounded-btn red action-btn action-btn-reject"
                                                                    disabled={loading}
                                                                >
                                                                    {loading ? (
                                                                        <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                                                    ) : (
                                                                        <>
                                                                            <FaRegCircleXmark className="action-btn-icon" />
                                                                            <span>Reject</span>
                                                                        </>
                                                                    )}
                                                                </Button>
                                                                <Button
                                                                    onClick={openApproveConfirm}
                                                                    className="custom-rounded-btn blue action-btn action-btn-confirm"
                                                                    disabled={isOnlinePaymentPending || loading}
                                                                >
                                                                    {isOnlinePaymentPending ? (
                                                                        <span>Waiting for Payment</span>
                                                                    ) : (
                                                                        <>
                                                                            <FaRegCircleCheck className="action-btn-icon" />
                                                                            <span>Confirm</span>
                                                                        </>
                                                                    )}
                                                                </Button>
                                                            </>
                                                        )}

                                                        {(orderData?.status === 'INITIATED' && (orderData?.orderType === 1 || orderData?.orderType === 2)) && (
                                                            <>
                                                                <Button
                                                                    onClick={openVideoPreview}
                                                                    className="custom-rounded-btn blue"
                                                                    disabled={isOnlinePaymentPending || loading}
                                                                >
                                                                    {isOnlinePaymentPending ? (
                                                                        <>
                                                                            <span className="ms-2">Waiting for Payment</span>
                                                                        </>
                                                                    ) : (
                                                                        `Check ${orderData?.orderType === 1 ? 'Return' : orderData?.orderType === 2 ? 'Exchange' : ''} Evidence`
                                                                    )}
                                                                </Button>
                                                            </>
                                                        )}


                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Next Step — a focused call-to-action block for the vendor */}
                                        {(() => {
                                            const toOrderIds = (value) => {
                                                if (!value) return [];
                                                return (Array.isArray(value) ? value : String(value).split(','))
                                                    .map((item) => String(item).trim())
                                                    .filter(Boolean);
                                            };
                                            const relatedOrderGroups = [
                                                { type: 'parent', label: 'Parent order', ids: toOrderIds(orderData?.parentOrderId) },
                                                { type: 'return', label: 'Return orders', ids: toOrderIds(orderData?.returnIdForVedor) },
                                                { type: 'exchange', label: 'Exchange orders', ids: toOrderIds(orderData?.exchangeIdForVedor) },
                                            ].filter(({ ids }) => ids.length);

                                            if (!relatedOrderGroups.length) return null;

                                            return (
                                                <div className="card custom-rounded-card related-orders-section">
                                                    <div className="card-body">
                                                        <h4 className="card-title mb-3">Related orders</h4>
                                                        <div className="related-orders-list">
                                                            {relatedOrderGroups.map(({ type, label, ids }) => (
                                                                <div key={type} className={`related-order-row related-order-row-${type}`}>
                                                                    <span className="related-order-label">{label} →</span>
                                                                    <span className="related-order-ids">
                                                                        {ids.map((relatedId, index) => (
                                                                            <React.Fragment key={relatedId}>
                                                                                {index > 0 && <span>,</span>}
                                                                                <button
                                                                                    type="button"
                                                                                    className="related-order-id"
                                                                                    onClick={() => navigate(`/orderdetails/${relatedId}`)}
                                                                                >
                                                                                    {relatedId}
                                                                                </button>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </span>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })()}

                                        {(() => {
                                            const s = orderData?.status;
                                            const t = orderData?.orderType;
                                            const sfe = orderData?.statusForExchangeOrder;
                                            const dStatus = orderData?.deliveryStatus;
                                            const pickupOtp = orderData?.pidgeOrder?.pickupOtp;
                                            const dropOtp = orderData?.pidgeOrder?.dropOtp;
                                            const isExchange = t === 2;

                                            const showConfirmReject = s === 'INITIATED' && (t === null || t === undefined);
                                            const showEvidence = s === 'INITIATED' && (t === 1 || t === 2);
                                            const showPickupOtp = s === 'CONFIRMED' && !!pickupOtp && (
                                                isExchange
                                                    ? sfe === 2
                                                    : ((t === null || t === undefined) && dStatus === 'PENDING')
                                            );
                                            const showDropOtp = s === 'CONFIRMED' && !!dropOtp && (
                                                isExchange
                                                    ? sfe === 1
                                                    : (t === 1 && dStatus === 'DISPATCHED')
                                            );

                                            if (!showConfirmReject && !showEvidence && !showPickupOtp && !showDropOtp) return null;

                                            let title = 'Next step';
                                            let subtitle = '';
                                            if (showConfirmReject) {
                                                subtitle = 'Approve or reject this order';
                                            } else if (showEvidence) {
                                                const kind = t === 1 ? 'return' : 'exchange';
                                                subtitle = `Review ${kind} evidence`;
                                            } else if (showPickupOtp) {
                                                subtitle = 'Share OTP with pickup driver';
                                            } else if (showDropOtp) {
                                                subtitle = 'Share OTP with delivery driver';
                                            }

                                            const otpValue = showPickupOtp ? pickupOtp : showDropOtp ? dropOtp : null;
                                            const otpLabel = showPickupOtp ? 'Pickup OTP' : showDropOtp ? 'Drop OTP' : '';

                                            return (
                                                <div className="od-next-step">
                                                    <div className="od-next-step-head">
                                                        <span className="od-next-step-badge">
                                                            <span className="od-live-dot" aria-hidden="true" />
                                                            <FaCircleChevronRight size={12} />
                                                            {title}
                                                        </span>
                                                        <div className="od-next-step-title">{subtitle}</div>
                                                    </div>

                                                    {otpValue && (
                                                        <div className="od-next-step-otp">
                                                            <div className="od-next-step-otp-label">{otpLabel}</div>
                                                            <div className="od-next-step-otp-digits">
                                                                {renderOtpDigits(otpValue)}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {(showConfirmReject || showEvidence) && (
                                                        <div className="od-next-step-actions">
                                                            {showEvidence && (
                                                                <button
                                                                    type="button"
                                                                    className="od-ns-btn od-ns-btn-evidence"
                                                                    onClick={openVideoPreview}
                                                                    disabled={loading}
                                                                >
                                                                    <FiPlayCircle size={15} />
                                                                    Check Evidence
                                                                </button>
                                                            )}
                                                            {showConfirmReject && (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="od-ns-btn od-ns-btn-reject"
                                                                        onClick={() => { setRejectionReason(''); setCustomReason(''); setShowRejectConfirm(true); }}
                                                                        disabled={loading}
                                                                    >
                                                                        <FaRegCircleXmark size={13} />
                                                                        Reject
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="od-ns-btn od-ns-btn-confirm"
                                                                        onClick={openApproveConfirm}
                                                                        disabled={isOnlinePaymentPending || loading}
                                                                    >
                                                                        {isOnlinePaymentPending ? (
                                                                            <>Waiting for Payment</>
                                                                        ) : (
                                                                            <>
                                                                                <FaRegCircleCheck size={13} />
                                                                                Confirm Order
                                                                            </>
                                                                        )}
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })()}

                                        {orderData?.isScheduled && orderData?.scheduledOrderJobs?.length > 0 && (
                                            <div className="card custom-rounded-card mb-3">
                                                <div className="card-body py-3">
                                                    <div className="d-flex justify-content-between align-items-center flex-wrap">

                                                        <div className="d-flex align-items-center gap-3">
                                                            <div
                                                                style={{
                                                                    width: "42px",
                                                                    height: "42px",
                                                                    borderRadius: "10px",
                                                                    background: "#fff3cd",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center"
                                                                }}
                                                            >
                                                                <FaRegCalendarAlt size={20} color="#856404" />
                                                            </div>

                                                            <div>
                                                                <h6
                                                                    className="mb-1"
                                                                    style={{
                                                                        fontWeight: 700,
                                                                        color: "#856404"
                                                                    }}
                                                                >
                                                                    Scheduled Order
                                                                </h6>

                                                                <div
                                                                    className="d-flex align-items-center gap-3 flex-wrap"
                                                                    style={{
                                                                        fontSize: "12px",
                                                                        fontWeight: 500
                                                                    }}
                                                                >
                                                                    <span>
                                                                        {moment(
                                                                            orderData?.scheduledOrderJobs?.[0]?.scheduledDate
                                                                        ).format("DD MMM YYYY")}
                                                                    </span>

                                                                    <span
                                                                        style={{
                                                                            width: "5px",
                                                                            height: "5px",
                                                                            borderRadius: "50%",
                                                                            background: "#adb5bd",
                                                                            display: "inline-block"
                                                                        }}
                                                                    />

                                                                    <span>
                                                                        {
                                                                            orderData?.scheduledOrderJobs?.[0]?.slot
                                                                                ?.label
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="mt-3 mt-md-0">
                                                            <span
                                                                className={`badge px-3 py-2 ${orderData?.scheduledOrderJobs?.[0]?.status ===
                                                                        "PENDING"
                                                                        ? "bg-warning text-dark"
                                                                        : orderData?.scheduledOrderJobs?.[0]
                                                                            ?.status === "COMPLETED"
                                                                            ? "bg-success"
                                                                            : orderData?.scheduledOrderJobs?.[0]
                                                                                ?.status === "CANCELLED"
                                                                                ? "bg-danger"
                                                                                : "bg-secondary"
                                                                    }`}
                                                                style={{
                                                                    fontSize: "11px",
                                                                    borderRadius: "6px",
                                                                    letterSpacing: "0.5px"
                                                                }}
                                                            >
                                                                {orderData?.scheduledOrderJobs?.[0]?.status}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        <OrderStatusTracker
                                            status={orderData?.status}
                                            type={orderData?.orderType}
                                            paymentMode={orderData?.paymentMode}
                                            paymentStatus={orderData?.paymentStatus}
                                            pidgeOrder={orderData?.pidgeOrder}
                                        />

                                        <div className="row">
                                            {/* Order Details on Left */}
                                            <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <div className='d-flex justify-content-between align-items-center mb-4'>
                                                            <h4 className="card-title mb-0">Product details</h4>

                                                        </div>

                                                        {orderData?.orderProducts?.length === 0 ? (
                                                            <div className='text-center py-4'>
                                                                <p>No products found</p>
                                                            </div>
                                                        ) : (
                                                            orderData?.orderProducts?.map((item, i) => {
                                                                // Find returns for this specific product using orderproductid
                                                                const productReturns = orderData.orderProducts.flatMap(product =>
                                                                    product.returns || []
                                                                ).filter(returnItem => returnItem.orderproductid === item.id);

                                                                const hasReturnOrExchange = productReturns.length > 0;
                                                                const returnType = hasReturnOrExchange ? productReturns[0].type : null;
                                                                const returnStatus = hasReturnOrExchange ? productReturns[0].status : null;

                                                                return (
                                                                    <div
                                                                        key={i}
                                                                        className={i < orderData.orderProducts.length - 1 ? 'border-bottom pb-3 mb-3' : ''}
                                                                    >
                                                                        <div className='d-flex'>
                                                                            <div className='me-3 position-relative'>

                                                                                <div style={{ height: "80px", width: "80px" }}>
                                                                                    {item?.Product?.images?.[0]?.image_url !== '' ?
                                                                                        <img
                                                                                            src={item?.Product?.images?.[0]?.image_url}

                                                                                            className="img-fluid custom-rounded-img"
                                                                                            style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                                                                            onError={(e) => {
                                                                                                e.target.onerror = null;
                                                                                                e.target.src = '';
                                                                                            }}
                                                                                        /> : <BsImageAlt size={80} color="#ccc" />}

                                                                                </div>




                                                                                {/* RETURN/EXCHANGE STAMP - ADDED THIS CODE */}
                                                                                {hasReturnOrExchange && (
                                                                                    <div
                                                                                        style={{
                                                                                            position: 'absolute',
                                                                                            top: '5px',
                                                                                            right: '5px',
                                                                                            backgroundColor: returnType === 1
                                                                                                ? 'rgba(220, 53, 69, 0.9)'
                                                                                                : 'rgba(13, 110, 253, 0.9)',
                                                                                            color: 'white',
                                                                                            padding: '3px 6px',
                                                                                            borderRadius: '3px',
                                                                                            fontSize: '9px',
                                                                                            fontWeight: 'bold',
                                                                                            transform: 'rotate(15deg)',
                                                                                            boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
                                                                                            zIndex: 10,
                                                                                            textTransform: 'uppercase',
                                                                                            letterSpacing: '0.5px'
                                                                                        }}
                                                                                    >
                                                                                        {returnType === 1 ? 'Returned' : 'Exchanged'}
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <div className='flex-grow-1'>
                                                                                <h6 className="mb-1">{item?.Product?.productName}</h6>

                                                                                <div className="d-flex flex-wrap gap-2">
                                                                                    {item?.Product?.size && (
                                                                                        <div className="d-flex align-items-center">
                                                                                            <small className="text-muted me-1">Size:</small>
                                                                                            <small>{item?.Product?.size}</small>
                                                                                        </div>
                                                                                    )}

                                                                                    {item?.quantity && (
                                                                                        <div className="d-flex align-items-center">
                                                                                            <small className="text-muted me-1">Qty:</small>
                                                                                            <small>{item?.quantity}</small>
                                                                                        </div>
                                                                                    )}

                                                                                    {item?.VariationSize && (
                                                                                        <div className="d-flex align-items-center">
                                                                                            <small className="text-muted me-1">Size:</small>
                                                                                            <small>{item?.VariationSize?.size}</small>
                                                                                        </div>
                                                                                    )}
                                                                                </div>

                                                                                {/* Show return/exchange details if applicable */}
                                                                                {hasReturnOrExchange && (
                                                                                    <div className="mt-2 p-2 bg-light rounded">

                                                                                        {productReturns[0]?.reason && (
                                                                                            <small className="text-muted d-block">
                                                                                                Reason: {productReturns[0].reason}
                                                                                            </small>
                                                                                        )}
                                                                                        {productReturns[0]?.comments && (
                                                                                            <small className="text-muted d-block">
                                                                                                Comments: {productReturns[0].comments}
                                                                                            </small>
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                            </div>

                                                                            <div className='text-end'>
                                                                                <div className="d-flex flex-column" style={{ width: '120px' }}>
                                                                                    <h6 className="mb-0">Rs {item.originalDiscountedAmount * item.quantity}</h6>
                                                                                    <small className="text-muted text-decoration-line-through">Rs {item.originalBillingAmount * item.quantity}</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Vendor Details on Right */}
                                            {(userType === 'ADMIN' || userType === 'customerSupport') &&
                                                <div className='col-md-6 mb-4'>
                                                    <div className='card custom-rounded-card h-100'>
                                                        <div className='card-body'>
                                                            <h4 className="card-title mb-4">Vendor details</h4>
                                                            <Table className="custom-rounded-table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Store Name:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.storeName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Mobile Number:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.phoneNumber}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Email Address:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.email}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Address: </td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.orderProducts?.[0]?.Product?.manufacturer?.address}, {orderData?.orderProducts?.[0]?.Product?.manufacturer?.landmark}<br />
                                                                            {orderData?.orderProducts?.[0]?.Product?.manufacturer?.city}, {orderData?.orderProducts?.[0]?.Product?.manufacturer?.state}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </div>}

                                            {/* Amount paid by customer on Left */}
                                            {checkUserPermissions('admin') && orderData?.orderType !== 2 && <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">{orderData?.orderType === 1 ? 'Amount refunded to customer' : 'Amount paid by customer'}</h4>

                                                        <div className='mb-3'>
                                                            <div className='d-flex justify-content-between mb-2'>
                                                                <span>Amount</span>
                                                                <span>Rs  {amountToShowForCustomer + amountToShowForGettoDiscount}</span>

                                                            </div>

                                                            <div className='d-flex justify-content-between mb-2'>
                                                                <span>Discount amount</span>
                                                                <span>Rs  {amountToShowForGettoDiscount}</span>

                                                            </div>






                                                        </div>

                                                        <div className='d-flex justify-content-between border-top pt-3'>
                                                            <h5 className=''>{orderData?.orderType === 1 ? 'Refunded Amount' : 'Total Amount'}</h5>
                                                            <h5 className='fw-semibold'>Rs {amountToShowForCustomer.toFixed(2)}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}

                                            {/* Billing Details on right */}
                                            {(orderData?.orderType === null && (orderData?.status === "CONFIRMED" || orderData?.status === "INITIATED" || orderData?.status === "DELIVERED")) && <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">{userType == 'Vendor' ? 'Billing Details' : 'Amount paid to vendor'}</h4>

                                                        <div className='mb-3'>
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span>Amount</span>
                                                                <span>Rs {billingAmount.toFixed(2)}</span>
                                                            </div>

                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span>Commission ({commission}%)</span>
                                                                <span>Rs {commissionAmount.toFixed(2)}</span>
                                                            </div>


                                                        </div>

                                                        <div className='d-flex justify-content-between border-top pt-3'>
                                                            <h5 className=''>{orderData?.orderType === 1 ? 'Refundable Amount' : 'Total Amount'}</h5>
                                                            <h5 className='fw-semibold'>Rs {total.toFixed(2)}</h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}


                                            {/* Delivery Partner Charge and Offer Charges on Right */}

                                            {checkUserPermissions('admin') && orderData?.orderType !== 2
                                                ?
                                                <div className='col-md-12 mb-4'>
                                                    <div className='row h-100'>
                                                        <div className='col-md-6 mb-3 mb-md-0'>
                                                            <div className='card custom-rounded-card h-100'>
                                                                <div className='card-body'>
                                                                    <h4 className="card-title mb-4">Pidge delivery charge</h4>
                                                                    <div className='d-flex justify-content-between mb-2'>
                                                                        <span>Delivery Fee</span>
                                                                        <span>Rs {orderData?.voltaOrder === null ? orderData?.deliveryAmount : orderData?.voltaOrder?.minorAmount}</span>
                                                                    </div>

                                                                    <div className='d-flex justify-content-between border-top pt-2'>
                                                                        <h6>Total</h6>
                                                                        <h6>Rs {orderData?.voltaOrder === null ? orderData?.deliveryAmount : orderData?.voltaOrder?.minorAmount}</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className='card custom-rounded-card h-100'>
                                                                <div className='card-body'>
                                                                    <h4 className="card-title mb-4">Getto discount amount</h4>
                                                                    <div className='d-flex justify-content-between mb-2'>
                                                                        <span>Discount</span>
                                                                        <span>Rs.{amountToShowForGettoDiscount}</span>
                                                                    </div>

                                                                    <div className='d-flex justify-content-between border-top pt-2'>
                                                                        <h6>Total</h6>
                                                                        <h6>Rs.{amountToShowForGettoDiscount}</h6>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : <div></div>
                                            }


                                            <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">User details</h4>
                                                        {checkUserPermissions('admin') ? <NotMaskedUserData /> : <MaskedUserData />}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='col-md-6 mb-4'>
                                                <div className='card custom-rounded-card h-100'>
                                                    <div className='card-body'>
                                                        <h4 className="card-title mb-4">Order payment details</h4>
                                                            <Table className="custom-rounded-table">
                                                            <tbody>
                                                                {orderData?.paymentMode && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Payment Mode:</td>
                                                                        <td className='user-details-data'>{orderData?.paymentMode}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.paymentStatus && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Payment Status:</td>
                                                                        <td className='user-details-data'>{orderData?.paymentStatus}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.razorpayOrderId && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Razorpay Order ID:</td>
                                                                        <td className='user-details-data'>{orderData?.razorpayOrderId}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.shipRocketOrderId && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Shipment Order ID:</td>
                                                                        <td className='user-details-data'>{orderData?.shipRocketOrderId}</td>
                                                                    </tr>
                                                                )}
                                                                {orderData?.shiprocketShipmentId && (
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Shipment ID:</td>
                                                                        <td className='user-details-data'>{orderData?.shiprocketShipmentId}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </div>
                                            </div>

                                            {checkUserPermissions('admin') && (
                                                <div className='col-12 mb-4'>
                                                    <div className='card custom-rounded-card'>
                                                        <div className='card-body'>
                                                            <div className="d-flex justify-content-between align-items-center mb-4">
                                                                <h4 className="card-title mb-0">Delivery details</h4>
                                                                <Button variant="link" onClick={() => copyToClipBoard()} className="p-0">
                                                                    <FaRegCopy size={20} />
                                                                </Button>
                                                            </div>

                                                            <Table className="custom-rounded-table delivery-details-table">
                                                                <tbody>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Order ID:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.orderId ? orderData.orderId : "N/A"}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Store Name:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.storeName}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Store Number:</td>
                                                                        <td className='user-details-data'>{orderData?.orderProducts?.[0]?.Product?.manufacturer?.phoneNumber}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Pick Up Location:</td>
                                                                        <td className='user-details-data'>
                                                                            https://www.google.com/maps?q={orderData?.orderProducts?.[0]?.Product?.manufacturer?.latitude},{orderData?.orderProducts?.[0]?.Product?.manufacturer?.longitude}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Customer Name:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.Address?.customerName ? orderData.Address.customerName : "N/A"}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Customer Number:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.Address?.customerMobile ? `${orderData.Address.customerMobile}` : "N/A"}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Payment Mode:</td>
                                                                        <td className='user-details-data'> {orderData?.paymentMode} </td>
                                                                    </tr>
                                                                    <tr className={orderData?.paymentMode === 'ONLINE' ? 'mask-details' : ''}>
                                                                        <td className='user-details-subheading'>Cash to be collected:</td>
                                                                        <td className='user-details-data'>Rs.{orderData?.billingAmount}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Customer Address:</td>
                                                                        <td className='user-details-data'>
                                                                            {orderData?.Address?.line1}, {orderData?.Address?.line2}, {orderData?.Address?.locality}<br />
                                                                            {orderData?.Address?.city}, {orderData?.Address?.state}, Pincode: {orderData?.Address?.postalCode}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className='user-details-subheading'>Drop Location:</td>
                                                                        <td className='user-details-data'>
                                                                            https://www.google.com/maps?q={orderData?.Address?.latitude},{orderData?.Address?.longitude}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>)}


                    </div>
                    </>
                )}
            </div>

            {/* Return & Exchange Modal */}
            <Modal show={showOrder} onHide={handleCloseOrder} centered className="custom-rounded-modal">
                <Modal.Header closeButton className="border-bottom-0 pb-0">
                    <Modal.Title>
                        <h5 className="mb-0">
                            {orderItem?.type == "1" ? "Return" : "Exchange"} Order
                        </h5>
                        <small className="text-muted">Order Id: {orderData?.orderId}</small>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading ? (
                        <div className="text-center py-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="mb-4">
                                <h6 className="mb-3">Product Details</h6>

                                <div className="d-flex border rounded p-3 custom-rounded">
                                    <div className="me-3">
                                        <img
                                            src={orderItem?.orderItemProducts?.Product?.ProductImages?.[0]?.image_url}
                                            alt="product"
                                            className="img-fluid custom-rounded-img"
                                            style={{ width: '80px', height: '80px', objectFit: 'cover', background: 'red' }}
                                        />
                                    </div>

                                    <div className="flex-grow-1">
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <h6 className="mb-1">{orderItem?.orderItemProducts?.Product?.productName}</h6>

                                                <div className="d-flex flex-wrap gap-2">
                                                    {orderItem?.orderItemProducts?.Product?.size && (
                                                        <div className="d-flex align-items-center">
                                                            <small className="text-muted me-1">Size:</small>
                                                            <small>{orderItem?.orderItemProducts?.Product?.size}</small>
                                                        </div>
                                                    )}

                                                    {orderItem?.orderItemProducts?.quantity && (
                                                        <div className="d-flex align-items-center">
                                                            <small className="text-muted me-1">Qty:</small>
                                                            <small>{orderItem?.orderItemProducts?.quantity}</small>
                                                        </div>
                                                    )}

                                                    {orderItem?.orderItemProducts?.VariationSize && (
                                                        <div className="d-flex align-items-center">
                                                            <small className="text-muted me-1">Size:</small>
                                                            <small>{orderItem?.orderItemProducts?.VariationSize?.size}</small>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="text-end">
                                                <h6 className="mb-0">Rs {orderItem?.orderItemProducts?.Product?.discountedPrice}</h6>
                                                <small className="text-muted text-decoration-line-through">Rs {orderItem?.orderItemProducts?.Product?.price}</small>

                                                <div
                                                    className="mt-2 ms-auto color-code"
                                                ></div>
                                            </div>
                                        </div>

                                        {(orderItem?.orderItemProducts?.returns?.[0]?.comments || orderItem?.orderItemProducts?.returns?.[0]?.reason) && (
                                            <div className="mt-3 pt-2 border-top">
                                                {orderItem?.orderItemProducts?.returns?.[0]?.comments && (
                                                    <div className="mb-1">
                                                        <small className="text-muted">Comment:</small>
                                                        <small className="ms-2">{orderItem?.orderItemProducts?.returns?.[0]?.comments}</small>
                                                    </div>
                                                )}

                                                {orderItem?.orderItemProducts?.returns?.[0]?.reason && (
                                                    <div>
                                                        <small className="text-muted">Reason:</small>
                                                        <small className="ms-2">{orderItem?.orderItemProducts?.returns?.[0]?.reason}</small>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex justify-content-center gap-3">
                                <Button
                                    variant="outline-success"
                                    onClick={() => handleOrderReturnExchange(orderItem?.id, 2)}
                                    className="d-flex align-items-center custom-rounded-btn blue"
                                >
                                    <img src={tickIcon} alt="approve" className="me-2" /> Approve
                                </Button>
                                <Button
                                    variant="outline-danger"
                                    onClick={() => handleOrderReturnExchange(orderItem?.id, 3)}
                                    className="d-flex align-items-center custom-rounded-btn red"
                                >
                                    <img src={closeIcon} alt="reject" className="me-2" /> Reject
                                </Button>
                            </div>
                        </>
                    )}
                </Modal.Body>
            </Modal>

            {/* {(stickyVideo && (orderData.orderType == 1 || orderData.orderType == 2)) && (
                <div
                    className="sticky-video-container"
                    style={{
                        position: 'fixed',
                        bottom: '20px',
                        right: '20px',
                        zIndex: 1060,
                        width: '180px',
                        background: 'white',
                        borderRadius: '12px',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                        border: '1px solid #e0e0e0',
                        overflow: 'hidden', // ensures rounded corners apply to video too
                    }}
                >
                    <div className="sticky-video-player">
                        <div
                            className="video-header"
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '6px 10px',
                                background: '#f8f9fa',
                                borderBottom: '1px solid #dee2e6',
                            }}
                        >
                            <span style={{ fontSize: '11px', fontWeight: 700 }}>
                                {stickyVideo.type} Evidence Video
                            </span>
                            <button
                                onClick={() => setStickyVideo(null)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#6c757d',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '4px',
                                }}
                            >
                                <IoMdClose size={14} />
                            </button>
                        </div>

                        <video
                            key={stickyVideo.url}
                            autoPlay
                            muted
                            loop
                            controls
                            playsInline
                            style={{
                                width: '100%',
                                height: '160px', // reduced from 320px
                                objectFit: 'cover',
                                display: 'block',
                                background: '#000',
                                borderRadius: '0 0 12px 12px', // rounded bottom corners
                            }}
                        >
                            <source src={stickyVideo.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>
            )} */}

            {/* Evidence Check Modal */}
            <Modal
                show={showEvidenceModal}
                onHide={handleEvidenceModalClose}
                centered
                size="lg"
                dialogClassName="evidence-modal"
            >
                <style>{`
                    .evidence-modal .modal-dialog { max-width: 720px; }
                    .evidence-modal .modal-content { border: 0; border-radius: 12px; overflow: hidden; }
                    .evidence-modal .modal-header { padding: 14px 20px !important; border-bottom: 1px solid #e5e7eb; }
                    .evidence-modal .modal-header .modal-title { margin: 0 !important; padding: 0 !important; display: inline-flex; align-items: center; }
                    .evidence-modal .modal-header .btn-close { margin: 0 !important; padding: 8px !important; font-size: 12px; align-self: center; }
                    .evidence-modal .modal-body { padding: 0; max-height: 68vh; overflow-y: auto; }
                    .evidence-modal .modal-footer { padding: 10px 16px; border-top: 1px solid #e5e7eb; background: #f8fafc; }
                    .evidence-modal .evidence-title { display: inline-block; margin: 0; padding: 0; font-size: 14px; font-weight: 700; color: #0f172a; letter-spacing: -0.01em; line-height: 1.2; vertical-align: middle; }
                    .evidence-modal .evidence-col-left { padding: 14px 16px; border-right: 1px solid #e5e7eb; background: #fff; }
                    .evidence-modal .evidence-col-right { padding: 14px 16px; background: #f8fafc; }
                    .evidence-modal .evidence-section-label { margin: 0 0 8px; font-size: 12px; font-weight: 600; color: #0f172a; }
                    .evidence-modal .evidence-field-label { margin: 12px 0 4px; font-size: 11px; font-weight: 500; color: #475569; }
                    .evidence-modal .evidence-select,
                    .evidence-modal .evidence-textarea { font-size: 11px !important; border-radius: 6px !important; border: 1px solid #cbd5e1 !important; padding: 7px 10px !important; color: #0f172a; }
                    .evidence-modal .evidence-textarea { min-height: 84px !important; resize: vertical; }
                    .evidence-modal .evidence-select:focus,
                    .evidence-modal .evidence-textarea:focus { border-color: #008695 !important; box-shadow: 0 0 0 3px rgba(0, 134, 149, 0.1) !important; }
                    .evidence-modal .evidence-counter { margin-top: 4px; font-size: 10px; text-align: right; color: #94a3b8; }
                    .evidence-modal .evidence-counter.is-ok { color: #16a34a; }
                    .evidence-modal .evidence-video-frame { border: 1px solid #e5e7eb; border-radius: 8px; overflow: hidden; background: #000; height: 260px; display: flex; align-items: center; justify-content: center; }
                    .evidence-modal .evidence-video-empty { border: 1px dashed #cbd5e1; border-radius: 8px; background: #fff; height: 260px; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 6px; color: #94a3b8; text-align: center; padding: 16px; }
                    .evidence-modal .evidence-video-empty p { margin: 0; font-size: 11px; color: #64748b; }
                    .evidence-modal .evidence-btn { border-radius: 6px !important; padding: 6px 14px !important; font-size: 12px !important; font-weight: 600 !important; min-width: 88px; display: inline-flex; align-items: center; justify-content: center; gap: 6px; }
                    @media (max-width: 767.98px) {
                        .evidence-modal .modal-dialog { margin: 8px; max-width: none; }
                        .evidence-modal .modal-body { max-height: calc(100vh - 200px); }
                        .evidence-modal .evidence-col-left { border-right: 0; border-bottom: 1px solid #e5e7eb; padding: 12px 14px; }
                        .evidence-modal .evidence-col-right { padding: 12px 14px; }
                        .evidence-modal .evidence-video-frame,
                        .evidence-modal .evidence-video-empty { height: 200px; }
                        .evidence-modal .evidence-title { font-size: 13px; }
                        .evidence-modal .modal-footer { padding: 10px 12px; gap: 8px; }
                        .evidence-modal .evidence-btn { flex: 1; min-width: 0; padding: 8px 10px !important; font-size: 11px !important; }
                    }
                `}</style>

                <Modal.Header closeButton>
                    <Modal.Title as="span" className="evidence-title">
                        Check {orderData?.orderType == '1' ? 'Return' : 'Exchange'} Evidence
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {loading ? (
                        <div className="text-center py-4">
                            <Spinner animation="border" role="status" size="sm">
                                <span className="visually-hidden">Loading...</span>
                            </Spinner>
                        </div>
                    ) : (
                        <div className="row g-0">
                            <div className="col-md-6 evidence-col-left">
                                <h6 className="evidence-section-label">Rejection Reason</h6>
                                <Form.Group>
                                    <Form.Select
                                        className="evidence-select"
                                        value={rejectionReason}
                                        onChange={(e) => setRejectionReason(e.target.value)}
                                    >
                                        <option value="">Choose a rejection reason...</option>
                                        {rejectionReasons.map((reason, index) => (
                                            <option key={index} value={reason}>{reason}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label className="evidence-field-label">Any other reason</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        className="evidence-textarea"
                                        rows={4}
                                        placeholder="Provide specific reason for rejection (minimum 10 characters)..."
                                        value={customReason}
                                        onChange={(e) => setCustomReason(e.target.value)}
                                    />
                                    <div className={`evidence-counter${customReason && customReason.trim().length >= 10 ? ' is-ok' : ''}`}>
                                        {customReason?.length || 0}/10 characters
                                        {customReason && customReason.trim().length >= 10 && ' ✓'}
                                    </div>
                                </Form.Group>
                            </div>

                            <div className="col-md-6 evidence-col-right">
                                {stickyVideo ? (
                                    <div className="evidence-video-frame">
                                        <video
                                            key={stickyVideo.url}
                                            controls
                                            autoPlay
                                            muted
                                            playsInline
                                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                                        >
                                            <source src={stickyVideo.url} type="video/mp4" />
                                            Your browser does not support the video tag.
                                        </video>
                                    </div>
                                ) : (
                                    <div className="evidence-video-empty">
                                        <FiImage size={30} />
                                        <p>No evidence video available</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button
                        variant="danger"
                        className="evidence-btn"
                        onClick={handleRejectOrder}
                        disabled={loading || !(rejectionReason || (customReason && customReason.trim().length >= 10))}
                    >
                        {evidenceAction === 'REJECT' ? (<><Spinner as="span" animation="border" size="sm" /> Processing...</>) : 'Reject'}
                    </Button>
                    <Button
                        variant="success"
                        className="evidence-btn"
                        onClick={handleApproveOrder}
                        disabled={loading || (rejectionReason || (customReason.trim().length > 0))}
                    >
                        {evidenceAction === 'APPROVE' ? (<><Spinner as="span" animation="border" size="sm" /> Processing...</>) : 'Confirm'}
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* CSS Styles */}
            <style>
                {`
                .hide-scrollbar::-webkit-scrollbar {
                    display: none; /* Chrome, Safari */
                }
                .hide-scrollbar {
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;     /* Firefox */
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
            </style>

            {/* Mobile-only fixed bottom invoice bar (delivered orders) */}
            {orderData?.status === 'DELIVERED' &&
              orderData?.orderType == null &&
              orderData?.returnId == null && (
                <div className="od-invoice-bar">
                    <button
                        type="button"
                        className="od-invoice-btn-m"
                        onClick={handleDownloadVendorInvoice}
                        disabled={downloadVendorInvoice}
                    >
                        {downloadVendorInvoice ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" />
                                <span>Downloading…</span>
                            </>
                        ) : (
                            <>
                                <FaDownload size={12} />
                                <span>Vendor invoice</span>
                            </>
                        )}
                    </button>
                    <button
                        type="button"
                        className="od-invoice-btn-m od-invoice-btn-m-primary"
                        onClick={handleDownloadCustomerInvoice}
                        disabled={downloadCustomerInvoice}
                    >
                        {downloadCustomerInvoice ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" />
                                <span>Downloading…</span>
                            </>
                        ) : (
                            <>
                                <FaDownload size={12} />
                                <span>Customer invoice</span>
                            </>
                        )}
                    </button>
                </div>
            )}

            {/* Video Preview Modal — evidence-only view for exchange / return orders */}
            <Modal
                show={showVideoPreview}
                onHide={closeVideoPreview}
                centered
                size="md"
                dialogClassName="od-video-preview-modal"
            >
                <style>{`
                  .od-video-preview-modal .modal-dialog { max-width: 560px; }
                  .od-video-preview-modal .modal-content { border: 0; border-radius: 12px; overflow: hidden; }
                  .od-video-preview-modal .modal-header {
                    display: flex !important;
                    align-items: center !important;
                    padding: 12px 20px !important;
                    min-height: 52px !important;
                    border-bottom: 1px solid #e5e7eb;
                  }
                  .od-video-preview-modal .modal-header .modal-title { margin: 0 !important; padding: 0 !important; display: inline-flex !important; align-items: center !important; }
                  .od-video-preview-modal .modal-header .btn-close { margin: 0 !important; padding: 8px !important; align-self: center !important; }
                  .od-video-preview-modal .vp-title { font-size: 14px; font-weight: 700; color: #0f172a; letter-spacing: -0.01em; line-height: 1; }
                  .od-video-preview-modal .modal-body { padding: 16px 20px; background: #f8fafc; }
                  .od-video-preview-modal .vp-video-frame {
                    border: 1px solid #e5e7eb;
                    border-radius: 10px;
                    overflow: hidden;
                    background: #000;
                    height: 300px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 14px;
                  }
                  .od-video-preview-modal .vp-video-empty {
                    border: 1px dashed #cbd5e1;
                    border-radius: 10px;
                    background: #fff;
                    height: 300px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    color: #94a3b8;
                    text-align: center;
                    padding: 20px;
                    margin-bottom: 14px;
                  }
                  .od-video-preview-modal .vp-video-empty p { margin: 0; font-size: 12px; color: #64748b; }
                  .od-video-preview-modal .vp-info-block {
                    padding: 12px 14px;
                    background: #fff;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                  }
                  .od-video-preview-modal .vp-info-row { display: flex; gap: 8px; align-items: flex-start; }
                  .od-video-preview-modal .vp-info-row + .vp-info-row { margin-top: 8px; }
                  .od-video-preview-modal .vp-info-label {
                    flex-shrink: 0;
                    font-size: 10px;
                    font-weight: 600;
                    color: #64748b;
                    text-transform: uppercase;
                    letter-spacing: 0.04em;
                    min-width: 72px;
                    padding-top: 2px;
                  }
                  .od-video-preview-modal .vp-info-value {
                    font-size: 12px;
                    font-weight: 500;
                    color: #0f172a;
                    line-height: 1.45;
                    word-wrap: break-word;
                    overflow-wrap: anywhere;
                  }
                  .od-video-preview-modal .vp-info-empty { color: #94a3b8; font-weight: 400; font-style: italic; }
                  .od-video-preview-modal .modal-footer {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: flex-end !important;
                    padding: 10px 16px !important;
                    min-height: 54px !important;
                    border-top: 1px solid #e5e7eb;
                    background: #fff;
                    gap: 8px;
                  }
                  .od-video-preview-modal .modal-footer > * { margin: 0 !important; }
                  .od-video-preview-modal .vp-btn {
                    padding: 6px 16px;
                    height: 34px;
                    border-radius: 6px;
                    font-size: 12px;
                    font-weight: 700;
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    cursor: pointer;
                    transition: all 0.15s ease;
                  }
                  .od-video-preview-modal .vp-btn-reject { border: 1px solid #fecdd3; background: #fff1f2; color: #be123c; }
                  .od-video-preview-modal .vp-btn-reject:hover { background: #ffe4e6; }
                  .od-video-preview-modal .vp-btn-accept { border: 0; background: #008695; color: #fff; box-shadow: 0 3px 8px rgba(0, 134, 149, 0.22); }
                  .od-video-preview-modal .vp-btn-accept:hover { background: #007784; }
                  @media (max-width: 575.98px) {
                    .od-video-preview-modal .modal-dialog { margin: 8px; max-width: none; }
                    .od-video-preview-modal .vp-video-frame,
                    .od-video-preview-modal .vp-video-empty { height: 220px; }
                  }
                `}</style>
                <Modal.Header closeButton>
                    <Modal.Title as="span" className="vp-title">
                        {videoPreviewData.orderType === 2 ? 'Exchange' : videoPreviewData.orderType === 1 ? 'Return' : ''} Evidence · {videoPreviewData.orderId}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {videoPreviewData.videoUrl ? (
                        <div className="vp-video-frame">
                            <video
                                key={videoPreviewData.videoUrl}
                                controls
                                autoPlay
                                muted
                                playsInline
                                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                            >
                                <source src={videoPreviewData.videoUrl} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    ) : (
                        <div className="vp-video-empty">
                            <FiImage size={32} />
                            <p>No evidence video available</p>
                        </div>
                    )}
                    <div className="vp-info-block">
                        <div className="vp-info-row">
                            <span className="vp-info-label">Reason</span>
                            <span className={`vp-info-value${videoPreviewData.reason ? '' : ' vp-info-empty'}`}>
                                {videoPreviewData.reason || 'Not provided'}
                            </span>
                        </div>
                        <div className="vp-info-row">
                            <span className="vp-info-label">Comment</span>
                            <span className={`vp-info-value${videoPreviewData.comments ? '' : ' vp-info-empty'}`}>
                                {videoPreviewData.comments || 'No comment provided'}
                            </span>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="vp-btn vp-btn-reject" onClick={handleVideoPreviewReject}>
                        <FiX size={13} />
                        Reject
                    </button>
                    <button type="button" className="vp-btn vp-btn-accept" onClick={handleVideoPreviewAccept}>
                        Accept
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Approve Confirmation Modal — reviews the products before calling approve */}
            <Modal
                show={showApproveConfirm}
                onHide={() => !loading && setShowApproveConfirm(false)}
                centered
                size="md"
                backdrop={loading ? 'static' : true}
                keyboard={!loading}
                dialogClassName="od-approve-order-modal"
            >
                <style>{`
                  .od-approve-order-modal .modal-dialog { max-width: 520px; }
                  .od-approve-order-modal .modal-content { border: 0; border-radius: 12px; overflow: hidden; }
                  .od-approve-order-modal .modal-header {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: space-between !important;
                    padding: 12px 20px !important;
                    min-height: 52px !important;
                    border-bottom: 1px solid #e5e7eb;
                  }
                  .od-approve-order-modal .modal-header .modal-title {
                    margin: 0 !important;
                    padding: 0 !important;
                    display: inline-block !important;
                    line-height: 1.2 !important;
                    white-space: normal;
                  }
                  .od-approve-order-modal .modal-header .btn-close {
                    margin: 0 !important;
                    padding: 8px !important;
                    align-self: center !important;
                  }
                  .od-approve-order-modal .modal-body { padding: 14px 20px; max-height: 60vh; overflow-y: auto; background: #f8fafc; }
                  .od-approve-order-modal .modal-footer {
                    display: flex !important;
                    align-items: center !important;
                    justify-content: flex-end !important;
                    padding: 10px 16px !important;
                    min-height: 54px !important;
                    border-top: 1px solid #e5e7eb;
                    background: #fff;
                    gap: 8px;
                  }
                  .od-approve-order-modal .modal-footer > * { margin: 0 !important; }
                  .od-approve-order-modal .ao-title {
                    display: inline-block;
                    margin: 0;
                    padding: 0;
                    font-size: 14px;
                    font-weight: 700;
                    color: #0f172a;
                    letter-spacing: -0.01em;
                    line-height: 1.2;
                    vertical-align: middle;
                  }
                  .od-approve-order-modal .ao-product {
                    display: flex;
                    gap: 12px;
                    padding: 10px;
                    background: #fff;
                    border: 1px solid #e5e7eb;
                    border-radius: 10px;
                    margin-bottom: 8px;
                  }
                  .od-approve-order-modal .ao-product:last-child { margin-bottom: 0; }
                  .od-approve-order-modal .ao-product-img,
                  .od-approve-order-modal .ao-product-img-fallback {
                    width: 64px; height: 64px; flex-shrink: 0;
                    border-radius: 8px; object-fit: cover;
                    border: 1px solid #e2e8f0; background: #f1f5f9;
                  }
                  .od-approve-order-modal .ao-product-img-fallback {
                    display: inline-flex; align-items: center; justify-content: center;
                    color: #94a3b8; font-size: 10px; font-weight: 600;
                  }
                  .od-approve-order-modal .ao-product-body { flex: 1; min-width: 0; display: flex; flex-direction: column; }
                  .od-approve-order-modal .ao-product-name {
                    margin: 0;
                    font-size: 12.5px;
                    font-weight: 700;
                    color: #0f172a;
                    letter-spacing: -0.01em;
                    line-height: 1.3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .od-approve-order-modal .ao-product-store {
                    display: block;
                    margin-top: 2px;
                    margin-bottom: 8px;
                    font-size: 10px;
                    font-weight: 600;
                    color: #64748b;
                    line-height: 1.2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .od-approve-order-modal .ao-product-meta {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    gap: 4px 6px;
                    font-size: 10px;
                    color: #475569;
                  }
                  .od-approve-order-modal .ao-name-store-gap { height: 8px; }
                  .od-approve-order-modal .ao-chip {
                    display: inline-flex;
                    align-items: center;
                    gap: 3px;
                    padding: 2px 7px;
                    border-radius: 999px;
                    background: #f1f5f9;
                    font-weight: 600;
                    white-space: nowrap;
                  }
                  .od-approve-order-modal .ao-chip-size {
                    background: #e0f2fe;
                    color: #0369a1;
                    font-size: 12px !important;
                    font-weight: 800 !important;
                    padding: 4px 10px !important;
                    letter-spacing: 0.03em;
                    border: 1.5px solid #7dd3fc;
                    box-shadow: 0 1px 2px rgba(3, 105, 161, 0.12);
                    text-transform: uppercase;
                  }
                  .od-approve-order-modal .ao-color-chip {
                    display: inline-flex;
                    align-items: center;
                    gap: 6px;
                    padding: 2px 8px 2px 4px;
                    border-radius: 999px;
                    background: #f8fafc;
                    border: 1px solid #e2e8f0;
                    font-weight: 600;
                    color: #334155;
                    white-space: nowrap;
                  }
                  .od-approve-order-modal .ao-color-swatch {
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    border: 1px solid rgba(15, 23, 42, 0.15);
                    box-shadow: inset 0 0 0 1px rgba(255,255,255,0.4);
                    flex-shrink: 0;
                  }
                  .od-approve-order-modal .ao-product-price {
                    margin-left: auto;
                    padding-left: 8px;
                    font-size: 12.5px;
                    font-weight: 800;
                    color: #0f172a;
                    font-variant-numeric: tabular-nums;
                    flex-shrink: 0;
                  }
                  .od-approve-order-modal .ao-total-row {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 10px 12px;
                    margin-top: 8px;
                    background: #ecfdf5;
                    border: 1px solid #bbf7d0;
                    border-radius: 10px;
                    font-size: 12px;
                    font-weight: 700;
                    color: #166534;
                  }
                  .od-approve-order-modal .ao-total-row .ao-total-value {
                    font-size: 14px;
                    font-variant-numeric: tabular-nums;
                  }
                `}</style>
                <Modal.Header closeButton={!loading}>
                    <Modal.Title as="span" className="ao-title">
                        {(() => {
                            const t = orderData?.orderType;
                            const sfe = orderData?.statusForExchangeOrder;
                            let kindLabel = 'new';
                            let kindColor = '#0369a1';
                            if (t === 2) {
                                if (sfe === 1) { kindLabel = 'exchange return'; kindColor = '#b45309'; }
                                else if (sfe === 2) { kindLabel = 'exchange delivery'; kindColor = '#1d4ed8'; }
                                else { kindLabel = 'exchange'; kindColor = '#6d28d9'; }
                            } else if (t === 1) {
                                kindLabel = 'return'; kindColor = '#b91c1c';
                            } else {
                                kindLabel = 'new'; kindColor = '#0369a1';
                            }
                            return (
                                <>
                                    Approve{' '}
                                    <span style={{ color: kindColor, fontWeight: 800, textTransform: 'capitalize' }}>{kindLabel}</span>
                                    {' '}order {orderData?.orderId}?
                                </>
                            );
                        })()}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {(orderData?.orderProducts || []).length === 0 ? (
                        <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8', fontSize: 12 }}>No products in this order.</div>
                    ) : (
                        (orderData?.orderProducts || []).map((item, i) => {
                            const p = item?.Product || {};
                            const img = p?.thumbnailImageUrl || p?.images?.[0]?.image_url || '';
                            const size = item?.VariationSize?.size || item?.productParameter?.size || p?.size || null;
                            const price = item?.pricePaidByCustomer ?? item?.price ?? 0;
                            return (
                                <div key={item?.id || i} className="ao-product">
                                    {img ? (
                                        <img
                                            src={img}
                                            alt={p?.productName || 'product'}
                                            className="ao-product-img"
                                            onError={(e) => { e.currentTarget.style.display = 'none'; }}
                                        />
                                    ) : (
                                        <span className="ao-product-img-fallback">N/A</span>
                                    )}
                                    <div className="ao-product-body">
                                        <h6 className="ao-product-name">{p?.productName || 'Unnamed product'}</h6>
                                        {userType === 'ADMIN' && p?.manufacturer?.storeName ? (
                                            <span className="ao-product-store" title={p.manufacturer.storeName}>
                                                {p.manufacturer.storeName}
                                            </span>
                                        ) : (
                                            <span className="ao-name-store-gap" aria-hidden="true" />
                                        )}
                                        <div className="ao-product-meta">
                                            {p?.color && (
                                                <span className="ao-color-chip" title={p.color}>
                                                    <span className="ao-color-swatch" style={{ background: p.color }} />
                                                    {p.color}
                                                </span>
                                            )}
                                            {(size || item?.quantity != null) && (
                                                <span className="ao-chip ao-chip-size">
                                                    {size || 'N/A'} × {item?.quantity ?? 1}
                                                </span>
                                            )}
                                            <span className="ao-product-price">₹{Number(price || 0).toLocaleString('en-IN')}</span>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                    {(() => {
                        const orderTotal = userType === 'ADMIN' ? orderData?.amount : orderData?.billingAmount;
                        if (orderTotal == null) return null;
                        return (
                            <div className="ao-total-row">
                                <span>Order total</span>
                                <span className="ao-total-value">₹{Number(orderTotal || 0).toLocaleString('en-IN')}</span>
                            </div>
                        );
                    })()}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        onClick={confirmApproveOrder}
                        disabled={loading}
                        style={{
                            padding: '6px 16px',
                            height: 34,
                            borderRadius: 6,
                            border: 0,
                            background: '#008695',
                            color: '#fff',
                            fontSize: 12,
                            fontWeight: 700,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: 6,
                            boxShadow: '0 3px 8px rgba(0, 134, 149, 0.22)',
                        }}
                    >
                        {loading ? (<><Spinner as="span" animation="border" size="sm" /> Approving...</>) : (<>Confirm &amp; Approve</>)}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* Reject order confirmation */}
            <Modal
                show={showRejectConfirm}
                onHide={() => !loading && setShowRejectConfirm(false)}
                centered
                backdrop={loading ? 'static' : true}
                keyboard={!loading}
                dialogClassName="reject-order-modal"
                contentClassName="reject-order-modal-content"
            >
                <style>{`
                  .reject-order-modal { max-width: 460px; }
                  .reject-order-modal-content {
                    border: none !important;
                    border-radius: 14px !important;
                    box-shadow: 0 20px 50px rgba(15,23,42,0.18) !important;
                    overflow: hidden !important;
                  }
                  .reject-order-modal .ro-title-kind {
                    text-transform: capitalize;
                    font-weight: 800;
                  }
                  .reject-order-modal .ro-divider {
                    height: 1px;
                    background: #eef2f7;
                    margin: 14px -22px 12px;
                  }
                  .reject-order-modal .ro-field-label {
                    margin: 0 0 6px;
                    font-size: 11px;
                    font-weight: 600;
                    color: #0f172a;
                    letter-spacing: 0.01em;
                    text-align: left;
                  }
                  .reject-order-modal .ro-select,
                  .reject-order-modal .ro-textarea {
                    font-size: 12px !important;
                    border-radius: 8px !important;
                    border: 1px solid #cbd5e1 !important;
                    padding: 8px 10px !important;
                    color: #0f172a;
                    width: 100%;
                    box-sizing: border-box;
                  }
                  .reject-order-modal .ro-textarea { min-height: 74px !important; resize: vertical; }
                  .reject-order-modal .ro-select:focus,
                  .reject-order-modal .ro-textarea:focus {
                    border-color: #dc2626 !important;
                    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.1) !important;
                    outline: none;
                  }
                  .reject-order-modal .ro-counter {
                    margin-top: 4px;
                    font-size: 10px;
                    text-align: right;
                    color: #94a3b8;
                  }
                  .reject-order-modal .ro-counter.is-ok { color: #16a34a; }
                  @media (max-width: 480px) {
                    .reject-order-modal { max-width: none !important; width: calc(100vw - 24px) !important; margin: 0 auto !important; }
                  }
                `}</style>
                <Modal.Body style={{ padding: '22px 22px 18px', textAlign: 'center' }}>
                    <div
                        style={{
                            width: 52,
                            height: 52,
                            borderRadius: '50%',
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: 12,
                        }}
                    >
                        <FaRegCircleXmark size={22} />
                    </div>
                    <h5 style={{ fontSize: 16, fontWeight: 700, color: '#0f172a', margin: '0 0 6px', letterSpacing: '-0.01em' }}>
                        {(() => {
                            const t = orderData?.orderType;
                            const sfe = orderData?.statusForExchangeOrder;
                            let kindLabel = null;
                            let kindColor = '#dc2626';
                            if (t === 2) {
                                if (sfe === 1) { kindLabel = 'exchange return'; kindColor = '#b45309'; }
                                else if (sfe === 2) { kindLabel = 'exchange delivery'; kindColor = '#1d4ed8'; }
                                else { kindLabel = 'exchange'; kindColor = '#6d28d9'; }
                            } else if (t === 1) {
                                kindLabel = 'return'; kindColor = '#b91c1c';
                            }
                            return kindLabel ? (
                                <>
                                    Reject{' '}
                                    <span className="ro-title-kind" style={{ color: kindColor }}>{kindLabel}</span>
                                    {' '}order?
                                </>
                            ) : 'Reject this order?';
                        })()}
                    </h5>
                    <p style={{ fontSize: 12.5, color: '#64748b', margin: 0, lineHeight: 1.5 }}>
                        This action cannot be undone. The customer will be notified that their order has been rejected.
                    </p>

                    {(orderData?.orderType === 1 || orderData?.orderType === 2) && (
                        <>
                            <div className="ro-divider" />
                            <div>
                                <p className="ro-field-label">Rejection reason</p>
                                <Form.Select
                                    className="ro-select"
                                    value={rejectionReason}
                                    onChange={(e) => setRejectionReason(e.target.value)}
                                    disabled={loading}
                                >
                                    <option value="">Choose a rejection reason...</option>
                                    {rejectionReasons.map((reason, index) => (
                                        <option key={index} value={reason}>{reason}</option>
                                    ))}
                                </Form.Select>
                            </div>
                            <div style={{ marginTop: 10 }}>
                                <p className="ro-field-label">Any other reason</p>
                                <Form.Control
                                    as="textarea"
                                    className="ro-textarea"
                                    rows={3}
                                    placeholder="Provide specific reason for rejection (minimum 10 characters)..."
                                    value={customReason}
                                    onChange={(e) => setCustomReason(e.target.value)}
                                    disabled={loading}
                                />
                                <div className={`ro-counter${customReason && customReason.trim().length >= 10 ? ' is-ok' : ''}`}>
                                    {customReason?.length || 0}/10 characters
                                    {customReason && customReason.trim().length >= 10 && ' ✓'}
                                </div>
                            </div>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer
                    style={{
                        padding: '12px 18px',
                        borderTop: '1px solid #eef2f7',
                        display: 'flex',
                        gap: 8,
                        justifyContent: 'stretch',
                    }}
                >
                    <button
                        type="button"
                        onClick={() => setShowRejectConfirm(false)}
                        disabled={loading}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #e2e8f0',
                            background: '#fff',
                            color: '#0f172a',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: loading ? 0.6 : 1,
                            transition: 'all 0.15s ease',
                        }}
                    >
                        No
                    </button>
                    <button
                        type="button"
                        onClick={() => handleCancelOrder()}
                        disabled={loading || ((orderData?.orderType === 1 || orderData?.orderType === 2) && !(rejectionReason || (customReason && customReason.trim().length >= 10)))}
                        style={{
                            flex: 1,
                            height: 38,
                            borderRadius: 6,
                            border: '1px solid #dc2626',
                            background: '#dc2626',
                            color: '#fff',
                            fontSize: 12.5,
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            opacity: (loading || ((orderData?.orderType === 1 || orderData?.orderType === 2) && !(rejectionReason || (customReason && customReason.trim().length >= 10)))) ? 0.6 : 1,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 6,
                            boxShadow: '0 3px 8px rgba(220,38,38,0.22)',
                            transition: 'all 0.15s ease',
                        }}
                    >
                        {loading ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                Rejecting...
                            </>
                        ) : (
                            <>
                                <FaRegCircleXmark size={13} />
                                Yes, Reject
                            </>
                        )}
                    </button>
                </Modal.Footer>
            </Modal>

        </>
    )
}




export default OrderDetails
